<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
    <q-card>
      <q-card-main>
        <!-- SELECT RELATÓRIOS -->
        <div class="row">
          <div class="col-sm-12 col-xs-12">
            <g-select
              id="refRelatorios"
              name="refRelatorios"
              ref="refRelatorios"
              etiqueta="Relatórios"
              :foco="false"
              :itens="relatoriosArray"
              item-valor="codigo"
              item-etiqueta="descricao"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="relatorio"
            ></g-select>
          </div>
        </div>
        <!-- INÍCIO ROTEIROS DOS PROCESSOS -->
        <span v-if="relatorio == 'ROTEIROS_DOS_PROCESSOS'">
          <div class="row">
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refTipoProcesso"
                name="refTipoProcesso"
                ref="refTipoProcesso"
                etiqueta="Tipo de Processo"
                descricaoPrimaria="desTipoProcesso"
                valor="codTipoProcesso"
                :foco="false"
                :api=apiTipoProcesso
                v-model="codTipoProcesso"
              >
              </g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refAssunto"
                name="refAssunto"
                ref="refAssunto"
                etiqueta="Assunto"
                valor="codAssunto"
                descricaoPrimaria="desAssunto"
                :foco="false"
                :api=apiAssunto
                :desabilitar="desabilitarAssunto"
                v-model="codAssunto"
              >
              </g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSubAssunto"
                name="refSubAssunto"
                ref="refSubAssunto"
                etiqueta="Subassunto"
                valor="codSubassunto"
                descricaoPrimaria="desSubassunto"
                :api=apiSubAssunto
                :foco="false"
                :desabilitar="desabilitarSubAssunto"
                :filtroAdicional="filtroPesquisaSubAssunto"
                v-model="codSubassunto"
              >
              </g-autocomplete>
            </div>
          </div>
        </span>
        <!-- ROTEIROS DE PROCESSO  -->
        <!-- INÍCIO COMPROVANTE ENCAMINHAMENTO DE PROCESSO -->
        <span v-if="relatorio == 'COMPROVANTE_ENCAMINHAMENTO_PROCESSO'">
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumInicialProcesso"
                name="refnumInicialProcesso"
                ref="refnumInicialProcesso"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Inicial"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numInicialProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumFinalProcesso"
                name="refnumFinalProcesso"
                ref="refnumFinalProcesso"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numFinalProcesso"
              ></g-input>
            </div>
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
              ></g-datepicker> -->
              <g-dateInput
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
              ></g-datepicker> -->
              <g-dateInput
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xs-12">
              <g-autocomplete
                id="refRequerente"
                name="refRequerente"
                ref="refRequerente"
                etiqueta="Requerente"
                valor="codRequerente"
                :foco="false"
                descricaoPrimaria="nomeDataNascimentoDocumento"
                :desabilitar="paginaStatus.desabilitarEdicao"
                :api="apiRequerente"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="requerente.codRequerente"
              ></g-autocomplete>
            </div>
          </div>
        </span>
        <!-- FIM COMPROVANTE ENCAMINHAMENTO DE PROCESSO -->
        <!-- INÍCIO COMPROVANTE DE MOVIMENTAÇÃO DE PROCESSO -->
        <span v-if="relatorio == 'COMPROVANTE_MOVIMENTACAO_PROCESSO'">
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumInicialProcesso"
                ref="refnumInicialProcesso"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Inicial"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numInicialProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumFinalProcesso"
                name="refnumFinalProcesso"
                ref="refnumFinalProcesso"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numFinalProcesso"
              ></g-input>
            </div>
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
              ></g-datepicker> -->
              <g-dateInput
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
              >
              </g-datepicker> -->
              <g-dateInput
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xs-12">
              <g-autocomplete
                id="refRequerente"
                name="refRequerente"
                ref="refRequerente"
                etiqueta="Requerente"
                valor="codRequerente"
                :foco="false"
                descricaoPrimaria="nomeDataNascimentoDocumento"
                :desabilitar="paginaStatus.desabilitarEdicao"
                :api="apiRequerente"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="requerente.codRequerente"
              ></g-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refOrgaoOrigem"
                name="refOrgaoOrigem"
                ref="refOrgaoOrigem"
                validacao="text"
                etiqueta="Órgão de Origem"
                valor="codOrgao"
                descricaoPrimaria="desOrgao"
                :api="apiOrgao"
                :foco="false"
                v-model="codOrgaoOrigem"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refUnidadeOrigem"
                name="refUnidadeOrigem"
                ref="refUnidadeOrigem"
                etiqueta="Unidade de Origem"
                valor="codUnidade"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desUnidade"
                :desabilitar="desabilitarUnidadeOrigem"
                :api="apiUnidade"
                v-model="codUnidadeOrigem"
                :filtroAdicional="getFiltroUnidadeOrigem"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSetorOrigem"
                name="refSetorOrigem"
                ref="refSetorOrigem"
                etiqueta="Setor de Origem"
                valor="codSetor"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desSetor"
                :desabilitar="desabilitarSetorOrigem"
                :api="apiSetor"
                v-model="codSetorOrigem"
                :filtroAdicional="getFiltroSetorOrigem"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
              ></g-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refOrgaoDestino"
                name="refOrgaoDestino"
                ref="refOrgaoDestino"
                validacao="text"
                etiqueta="Órgão de Destino"
                valor="codOrgao"
                descricaoPrimaria="desOrgao"
                :api="apiOrgao"
                :foco="false"
                v-model="codOrgaoDestino"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refUnidadeDestino"
                name="refUnidadeDestino"
                ref="refUnidadeDestino"
                etiqueta="Unidade de Destino"
                valor="codUnidade"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desUnidade"
                :desabilitar="desabilitarUnidadeDestino"
                :api="apiUnidade"
                v-model="codUnidadeDestino"
                :filtroAdicional="getFiltroUnidadeDestino"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSetorDestino"
                name="refSetorDestino"
                ref="refSetorDestino"
                etiqueta="Setor de Destino"
                valor="codSetor"
                validacao="text"
                :foco="false"
                :desabilitar="desabilitarSetorDestino"
                descricaoPrimaria="desSetor"
                :api="apiSetor"
                v-model="codSetorDestino"
                :filtroAdicional="getFiltroSetorDestino"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
              ></g-autocomplete>
            </div>
          </div>
        </span>
        <!-- FIM COMPROVANTE DE MOVIMENTAÇÃO DE PROCESSO -->
        <!-- INÍCIO NOTIFICAÇÃO SOLICITAÇÃO DE COMPARECIMENTO -->
        <span v-if="relatorio == 'NOTIFICACAO_SOLICITACAO_COMPARECIMENTO'">
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumInicialProcesso"
                name="refnumInicialProcesso"
                ref="refnumInicialProcesso"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Inicial"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numInicialProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumFinalProcesso"
                name="refnumFinalProcesso"
                ref="refnumFinalProcesso"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numFinalProcesso"
              ></g-input>
            </div>
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
              ></g-datepicker> -->
              <g-dateInput
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
              ></g-datepicker> -->
              <g-dateInput
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xs-12">
              <g-autocomplete
                id="refRequerente"
                name="refRequerente"
                ref="refRequerente"
                etiqueta="Requerente"
                valor="codRequerente"
                :foco="false"
                descricaoPrimaria="nomeDataNascimentoDocumento"
                :desabilitar="paginaStatus.desabilitarEdicao"
                :api="apiRequerente"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="requerente.codRequerente"
              ></g-autocomplete>
            </div>
          </div>
        </span>
        <!-- FIM NOTIFICAÇÃO SOLICITAÇÃO DE COMPARECIMENTO -->
        <!-- INÍCIO NOTIFICAÇÃO DE COMUNIDADO DA SITUAÇÃO DO PROCESSO -->
        <span v-if="relatorio == 'NOTIFICACAO_COMUNICADO_SITUACAO_PROCESSO'">
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumInicialProcesso"
                name="refnumInicialProcesso"
                ref="refnumInicialProcesso"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Inicial"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numInicialProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumFinalProcesso"
                name="refnumFinalProcesso"
                ref="refnumFinalProcesso"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numFinalProcesso"
              ></g-input>
            </div>
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
              ></g-datepicker> -->
              <g-dateInput
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
              ></g-datepicker> -->
              <g-dateInput
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xs-12">
              <g-autocomplete
                id="refRequerente"
                name="refRequerente"
                ref="refRequerente"
                etiqueta="Requerente"
                valor="codRequerente"
                :foco="false"
                descricaoPrimaria="nomeDataNascimentoDocumento"
                :desabilitar="paginaStatus.desabilitarEdicao"
                :api="apiRequerente"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="requerente.codRequerente"
              ></g-autocomplete>
            </div>
          </div>
        </span>
        <!-- FIM NOTIFICAÇÃO DE COMUNIDADO DA SITUAÇÃO DO PROCESSO -->
        <!-- INÍCIO RELATÓRIO GERAL DE PROCESSOS -->
        <span v-if="relatorio == 'RELATORIO_GERAL_PROCESSOS'">
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumInicialProcesso"
                name="refnumInicialProcesso"
                ref="refnumInicialProcesso"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Inicial"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numInicialProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumFinalProcesso"
                name="refnumFinalProcesso"
                ref="refnumFinalProcesso"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numFinalProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoInicial"
                name="refAnoProcessoInicial"
                ref="refAnoProcessoInicial"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="4"
                etiqueta="Ano Inicial"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoInicial"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoFinal"
                name="refAnoProcessoFinal"
                ref="refAnoProcessoFinal"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="4"
                etiqueta="Ano Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoFinal"
              >
              </g-input>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
              ></g-datepicker> -->
              <g-dateInput
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
              >
              </g-datepicker> -->
              <g-dateInput
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
            <div class="col-sm-6 col-xs-6">
              <g-select
                id="refProcesso"
                name="refProcesso"
                ref="refProcesso"
                etiqueta="Status Atual"
                :foco="false"
                :itens="statusProcessoSemConfirmadoArray"
                item-valor="codigo"
                item-etiqueta="descricao"
                :desabilitar="paginaStatus.desabilitarEdicao"
                v-model="indStatusProcesso"
              >
              </g-select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <g-autocomplete
                id="refRequerente"
                name="refRequerente"
                ref="refRequerente"
                etiqueta="Requerente"
                valor="codRequerente"
                :foco="false"
                descricaoPrimaria="nomeDataNascimentoDocumento"
                :desabilitar="paginaStatus.desabilitarEdicao"
                :api="apiRequerente"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="requerente.codRequerente"
              ></g-autocomplete>
            </div>
            <div class="col-sm-6 col-xs-6">
              <g-autocomplete
                id="refUsuarioResponsavelAbertura"
                name="refUsuarioResponsavelAbertura"
                ref="refUsuarioResponsavelAbertura"
                etiqueta="Responsável pela abertura"
                valor="codUsuario"
                validacao="text"
                :foco="false"
                descricaoPrimaria="nomUsuario"
                :api=apiUsuario
                :desabilitar="paginaStatus.desabilitarEdicao"
                v-model="codUsuarioResponsavelAbertura"
              ></g-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xs-12 mrg-t-30 mrg-b-10">
              <div class="q-gutter-sm">
                <q-radio
                  id="radioLocalOrigem"
                  name="radioLocalOrigem"
                  v-model="local"
                  val="Origem"
                  label="Local de Origem"
                />
                &ensp;&ensp;
                <q-radio
                  id="radioLocalDestino"
                  name="radioLocalDestino"
                  v-model="local"
                  val="Destino"
                  label="Local de Destino"
                />
              </div>
            </div>
          </div>
          <div
            class="row"
            v-show="local == 'Origem'"
          >
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refOrgaoOrigem"
                name="refOrgaoOrigem"
                ref="refOrgaoOrigem"
                validacao="text"
                etiqueta="Órgão de Origem"
                valor="codOrgao"
                descricaoPrimaria="desOrgao"
                :api="apiOrgao"
                :foco="false"
                v-model="codOrgaoOrigem"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refUnidadeOrigem"
                name="refUnidadeOrigem"
                ref="refUnidadeOrigem"
                etiqueta="Unidade de Origem"
                valor="codUnidade"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desUnidade"
                :desabilitar="desabilitarUnidadeOrigem"
                :api="apiUnidade"
                v-model="codUnidadeOrigem"
                :filtroAdicional="getFiltroUnidadeOrigem"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSetorOrigem"
                name="refSetorOrigem"
                ref="refSetorOrigem"
                etiqueta="Setor de Origem"
                valor="codSetor"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desSetor"
                :desabilitar="desabilitarSetorOrigem"
                :api="apiSetor"
                v-model="codSetorOrigem"
                :filtroAdicional="getFiltroSetorOrigem"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
              ></g-autocomplete>
            </div>
          </div>
          <div
            class="row"
            v-show="local == 'Destino'"
          >
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refOrgaoDestino"
                name="refOrgaoDestino"
                ref="refOrgaoDestino"
                validacao="text"
                etiqueta="Órgão de Destino"
                valor="codOrgao"
                descricaoPrimaria="desOrgao"
                :api="apiOrgao"
                :foco="false"
                v-model="codOrgaoDestino"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refUnidadeDestino"
                name="refUnidadeDestino"
                ref="refUnidadeDestino"
                etiqueta="Unidade de Destino"
                valor="codUnidade"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desUnidade"
                :desabilitar="desabilitarUnidadeDestino"
                :api="apiUnidade"
                v-model="codUnidadeDestino"
                :filtroAdicional="getFiltroUnidadeDestino"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSetorDestino"
                name="refSetorDestino"
                ref="refSetorDestino"
                etiqueta="Setor de Destino"
                valor="codSetor"
                validacao="text"
                :foco="false"
                :desabilitar="desabilitarSetorDestino"
                descricaoPrimaria="desSetor"
                :api="apiSetor"
                v-model="codSetorDestino"
                :filtroAdicional="getFiltroSetorDestino"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
              ></g-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refTipoProcesso"
                name="refTipoProcesso"
                ref="refTipoProcesso"
                etiqueta="Tipo de Processo"
                descricaoPrimaria="desTipoProcesso"
                valor="codTipoProcesso"
                :foco="false"
                :api=apiTipoProcesso
                v-model="codTipoProcesso"
              >
              </g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refAssunto"
                name="refAssunto"
                ref="refAssunto"
                etiqueta="Assunto"
                valor="codAssunto"
                descricaoPrimaria="desAssunto"
                :foco="false"
                :api=apiAssunto
                :desabilitar="desabilitarAssunto"
                v-model="codAssunto"
              >
              </g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSubAssunto"
                name="refSubAssunto"
                ref="refSubAssunto"
                etiqueta="Subassunto"
                valor="codSubassunto"
                descricaoPrimaria="desSubassunto"
                :api=apiSubAssunto
                :foco="false"
                :desabilitar="desabilitarSubAssunto"
                :filtroAdicional="filtroPesquisaSubAssunto"
                v-model="codSubassunto"
              >
              </g-autocomplete>
            </div>
          </div>
        </span>
        <!-- FIM RELATÓRIO GERAL DE PROCESSOS -->
        <!-- INÍCIO RELATÓRIO OBSERVAÇÕES POR SEQUÊNCIA -->
        <span v-if="relatorio == 'RELATORIO_OBSERVACAO_SEQUENCIA'">
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumInicialProcesso"
                name="refnumInicialProcesso"
                ref="refnumInicialProcesso"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Inicial"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numInicialProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumFinalProcesso"
                name="refnumFinalProcesso"
                ref="refnumFinalProcesso"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numFinalProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoInicial"
                name="refAnoProcessoInicial"
                ref="refAnoProcessoInicial"
                tipo="text"
                validacao="Number"
                mascara="numero"
                etiqueta="Ano Inicial"
                :tamanho="4"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoInicial"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoFinal"
                name="refAnoProcessoFinal"
                ref="refAnoProcessoFinal"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="4"
                etiqueta="Ano Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoFinal"
              >
              </g-input>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
              ></g-datepicker> -->
              <g-dateInput
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
              >
              </g-datepicker> -->
              <g-dateInput
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
            <div class="col-sm-6 col-xs-6">
              <g-select
                id="refProcesso"
                name="refProcesso"
                ref="refProcesso"
                etiqueta="Status Atual"
                :foco="false"
                :itens="statusProcessoArray"
                item-valor="codigo"
                item-etiqueta="descricao"
                :desabilitar="paginaStatus.desabilitarEdicao"
                v-model="indStatusProcesso"
              >
              </g-select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <g-autocomplete
                id="refRequerente"
                name="refRequerente"
                ref="refRequerente"
                etiqueta="Requerente"
                valor="codRequerente"
                :foco="false"
                descricaoPrimaria="nomeDataNascimentoDocumento"
                :desabilitar="paginaStatus.desabilitarEdicao"
                :api="apiRequerente"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="requerente.codRequerente"
              ></g-autocomplete>
            </div>
            <div class="col-sm-6 col-xs-6">
              <g-autocomplete
                id="refUsuarioResponsavelAbertura"
                name="refUsuarioResponsavelAbertura"
                ref="refUsuarioResponsavelAbertura"
                etiqueta="Responsável pela abertura"
                valor="codUsuario"
                validacao="text"
                :foco="false"
                descricaoPrimaria="nomUsuario"
                :api=apiUsuario
                :desabilitar="paginaStatus.desabilitarEdicao"
                v-model="codUsuarioResponsavelAbertura"
              >
              </g-autocomplete>
            </div>

          </div>
          <div class="row">
            <div class="col-sm-12 col-xs-12 mrg-t-30 mrg-b-10">
              <div class="q-gutter-sm">
                <q-radio
                  id="radioLocalOrigem"
                  name="radioLocalOrigem"
                  v-model="local"
                  val="Origem"
                  label="Local de Origem"
                />
                &ensp;&ensp;
                <q-radio
                  id="radioLocalDestino"
                  name="radioLocalDestino"
                  v-model="local"
                  val="Destino"
                  label="Local de Destino"
                />
              </div>
            </div>
          </div>
          <div
            class="row"
            v-show="local == 'Origem'"
          >
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refOrgaoOrigem"
                name="refOrgaoOrigem"
                ref="refOrgaoOrigem"
                validacao="text"
                etiqueta="Órgão de Origem"
                valor="codOrgao"
                descricaoPrimaria="desOrgao"
                :api="apiOrgao"
                :foco="false"
                v-model="codOrgaoOrigem"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refUnidadeOrigem"
                name="refUnidadeOrigem"
                ref="refUnidadeOrigem"
                etiqueta="Unidade de Origem"
                valor="codUnidade"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desUnidade"
                :desabilitar="desabilitarUnidadeOrigem"
                :api="apiUnidade"
                v-model="codUnidadeOrigem"
                :filtroAdicional="getFiltroUnidadeOrigem"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSetorOrigem"
                name="refSetorOrigem"
                ref="refSetorOrigem"
                etiqueta="Setor de Origem"
                valor="codSetor"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desSetor"
                :desabilitar="desabilitarSetorOrigem"
                :api="apiSetor"
                v-model="codSetorOrigem"
                :filtroAdicional="getFiltroSetorOrigem"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
              ></g-autocomplete>
            </div>
          </div>
          <div
            class="row"
            v-show="local == 'Destino'"
          >
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refOrgaoDestino"
                name="refOrgaoDestino"
                ref="refOrgaoDestino"
                validacao="text"
                etiqueta="Órgão de Destino"
                valor="codOrgao"
                descricaoPrimaria="desOrgao"
                :api="apiOrgao"
                :foco="false"
                v-model="codOrgaoDestino"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refUnidadeDestino"
                name="refUnidadeDestino"
                ref="refUnidadeDestino"
                etiqueta="Unidade de Destino"
                valor="codUnidade"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desUnidade"
                :desabilitar="desabilitarUnidadeDestino"
                :api="apiUnidade"
                v-model="codUnidadeDestino"
                :filtroAdicional="getFiltroUnidadeDestino"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSetorDestino"
                name="refSetorDestino"
                ref="refSetorDestino"
                etiqueta="Setor de Destino"
                valor="codSetor"
                validacao="text"
                :foco="false"
                :desabilitar="desabilitarSetorDestino"
                descricaoPrimaria="desSetor"
                :api="apiSetor"
                v-model="codSetorDestino"
                :filtroAdicional="getFiltroSetorDestino"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
              ></g-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refTipoProcesso"
                name="refTipoProcesso"
                ref="refTipoProcesso"
                etiqueta="Tipo de Processo"
                descricaoPrimaria="desTipoProcesso"
                valor="codTipoProcesso"
                :foco="false"
                :api=apiTipoProcesso
                v-model="codTipoProcesso"
              >
              </g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refAssunto"
                name="refAssunto"
                ref="refAssunto"
                etiqueta="Assunto"
                valor="codAssunto"
                descricaoPrimaria="desAssunto"
                :foco="false"
                :api=apiAssunto
                :desabilitar="desabilitarAssunto"
                v-model="codAssunto"
              >
              </g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSubAssunto"
                name="refSubAssunto"
                ref="refSubAssunto"
                etiqueta="Subassunto"
                valor="codSubassunto"
                descricaoPrimaria="desSubassunto"
                :api=apiSubAssunto
                :foco="false"
                :desabilitar="desabilitarSubAssunto"
                :filtroAdicional="filtroPesquisaSubAssunto"
                v-model="codSubassunto"
              >
              </g-autocomplete>
            </div>
          </div>
        </span>
        <!-- FIM RELATÓRIO OBSERVAÇÕES POR SEQUÊNCIA -->
        <!-- INÍCIO RELATÓRIO MOVIMENTAÇÃO DOS PROCESSOS -->
        <span v-if="relatorio == 'RELATORIO_MOVIMENTACAO_PROCESSOS'">
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumInicialProcesso"
                name="refnumInicialProcesso"
                ref="refnumInicialProcesso"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Inicial"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numInicialProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumFinalProcesso"
                name="refnumFinalProcesso"
                ref="refnumFinalProcesso"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numFinalProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoInicial"
                name="refAnoProcessoInicial"
                ref="refAnoProcessoInicial"
                tipo="text"
                validacao="Number"
                mascara="numero"
                etiqueta="Ano Inicial"
                :tamanho="4"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoInicial"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoFinal"
                name="refAnoProcessoFinal"
                ref="refAnoProcessoFinal"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="4"
                etiqueta="Ano Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoFinal"
              >
              </g-input>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
              ></g-datepicker> -->
              <g-dateInput
                id="refDataMovimentacaoInicial"
                name="refDataMovimentacaoInicial"
                ref="refDataMovimentacaoInicial"
                etiqueta="Data Inicial"
                v-model="dataInicial"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
            <div
              class="col-sm-3 col-xs-3"
              style="padding-right: 30px;"
            >
              <!-- <g-datepicker
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
              >
              </g-datepicker> -->
              <g-dateInput
                id="refDatAtualizacaoFinal"
                name="refDatAtualizacaoFinal"
                ref="refDatAtualizacaoFinal"
                etiqueta="Data Final"
                v-model="dataFinal"
                :desabilitar="false"
                :somenteLeitura="paginaStatus.desabilitarEdicao"
                :dataMax="new Date()"
              >
              </g-dateInput>
            </div>
            <div class="col-sm-6 col-xs-6">
              <g-select
                id="refProcesso"
                name="refProcesso"
                ref="refProcesso"
                etiqueta="Status Atual"
                :foco="false"
                :itens="statusProcessoArray"
                item-valor="codigo"
                item-etiqueta="descricao"
                :desabilitar="paginaStatus.desabilitarEdicao"
                v-model="indStatusProcesso"
              >
              </g-select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <g-autocomplete
                id="refRequerente"
                name="refRequerente"
                ref="refRequerente"
                etiqueta="Requerente"
                valor="codRequerente"
                :foco="false"
                descricaoPrimaria="nomeDataNascimentoDocumento"
                :desabilitar="paginaStatus.desabilitarEdicao"
                :api="apiRequerente"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="requerente.codRequerente"
              ></g-autocomplete>
            </div>
            <div class="col-sm-6 col-xs-6">
              <g-autocomplete
                id="refUsuarioResponsavelAbertura"
                name="refUsuarioResponsavelAbertura"
                ref="refUsuarioResponsavelAbertura"
                etiqueta="Responsável pela abertura"
                valor="codUsuario"
                validacao="text"
                :foco="false"
                descricaoPrimaria="nomUsuario"
                :api=apiUsuario
                :desabilitar="paginaStatus.desabilitarEdicao"
                v-model="codUsuarioResponsavelAbertura"
              ></g-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xs-12 mrg-t-30 mrg-b-10">
              <div class="q-gutter-sm">
                <q-radio
                  id="radioLocalOrigem"
                  name="radioLocalOrigem"
                  v-model="local"
                  val="Origem"
                  label="Local de Origem"
                />
                &ensp;&ensp;
                <q-radio
                  id="radioLocalDestino"
                  name="radioLocalDestino"
                  v-model="local"
                  val="Destino"
                  label="Local de Destino"
                />
              </div>
            </div>
          </div>
          <div
            class="row"
            v-show="local == 'Origem'"
          >
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refOrgaoOrigem"
                name="refOrgaoOrigem"
                ref="refOrgaoOrigem"
                validacao="text"
                etiqueta="Órgão de Origem"
                valor="codOrgao"
                descricaoPrimaria="desOrgao"
                :api="apiOrgao"
                :foco="false"
                v-model="codOrgaoOrigem"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refUnidadeOrigem"
                name="refUnidadeOrigem"
                ref="refUnidadeOrigem"
                etiqueta="Unidade de Origem"
                valor="codUnidade"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desUnidade"
                :desabilitar="desabilitarUnidadeOrigem"
                :api="apiUnidade"
                v-model="codUnidadeOrigem"
                :filtroAdicional="getFiltroUnidadeOrigem"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSetorOrigem"
                name="refSetorOrigem"
                ref="refSetorOrigem"
                etiqueta="Setor de Origem"
                valor="codSetor"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desSetor"
                :desabilitar="desabilitarSetorOrigem"
                :api="apiSetor"
                v-model="codSetorOrigem"
                :filtroAdicional="getFiltroSetorOrigem"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
              ></g-autocomplete>
            </div>
          </div>
          <div
            class="row"
            v-show="local == 'Destino'"
          >
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refOrgaoDestino"
                name="refOrgaoDestino"
                ref="refOrgaoDestino"
                validacao="text"
                etiqueta="Órgão de Destino"
                valor="codOrgao"
                descricaoPrimaria="desOrgao"
                :api="apiOrgao"
                :foco="false"
                v-model="codOrgaoDestino"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refUnidadeDestino"
                name="refUnidadeDestino"
                ref="refUnidadeDestino"
                etiqueta="Unidade de Destino"
                valor="codUnidade"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desUnidade"
                :desabilitar="desabilitarUnidadeDestino"
                :api="apiUnidade"
                v-model="codUnidadeDestino"
                :filtroAdicional="getFiltroUnidadeDestino"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSetorDestino"
                name="refSetorDestino"
                ref="refSetorDestino"
                etiqueta="Setor de Destino"
                valor="codSetor"
                validacao="text"
                :foco="false"
                :desabilitar="desabilitarSetorDestino"
                descricaoPrimaria="desSetor"
                :api="apiSetor"
                v-model="codSetorDestino"
                :filtroAdicional="getFiltroSetorDestino"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
              ></g-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refTipoProcesso"
                name="refTipoProcesso"
                ref="refTipoProcesso"
                etiqueta="Tipo de Processo"
                descricaoPrimaria="desTipoProcesso"
                valor="codTipoProcesso"
                :foco="false"
                :api=apiTipoProcesso
                v-model="codTipoProcesso"
              >
              </g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refAssunto"
                name="refAssunto"
                ref="refAssunto"
                etiqueta="Assunto"
                valor="codAssunto"
                descricaoPrimaria="desAssunto"
                :foco="false"
                :api=apiAssunto
                :desabilitar="desabilitarAssunto"
                v-model="codAssunto"
              >
              </g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSubAssunto"
                name="refSubAssunto"
                ref="refSubAssunto"
                etiqueta="Subassunto"
                valor="codSubassunto"
                descricaoPrimaria="desSubassunto"
                :api=apiSubAssunto
                :foco="false"
                :desabilitar="desabilitarSubAssunto"
                :filtroAdicional="filtroPesquisaSubAssunto"
                v-model="codSubassunto"
              >
              </g-autocomplete>
            </div>
          </div>
        </span>
        <!-- FIM RELATÓRIO MOVIMENTAÇÃO DOS PROCESSOS -->
        <!-- INÍCIO RELATÓRIO MAPA ESTATÍSTICO -->
        <span v-if="relatorio == 'RELATORIO_MAPA_ESTATISTICO'">
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumInicialProcesso"
                name="refnumInicialProcesso"
                ref="refnumInicialProcesso"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Inicial"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numInicialProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refnumFinalProcesso"
                name="refnumFinalProcesso"
                ref="refnumFinalProcesso"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                etiqueta="Nº Processo Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numFinalProcesso"
              ></g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoInicial"
                name="refAnoProcessoInicial"
                ref="refAnoProcessoInicial"
                tipo="text"
                validacao="Number"
                mascara="numero"
                etiqueta="Ano Inicial"
                :tamanho="4"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoInicial"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoFinal"
                name="refAnoProcessoFinal"
                ref="refAnoProcessoFinal"
                tipo="text"
                validacao="Number"
                mascara="numero"
                :tamanho="4"
                etiqueta="Ano Final"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoFinal"
              >
              </g-input>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <g-autocomplete
                id="refTipoProcesso"
                name="refTipoProcesso"
                ref="refTipoProcesso"
                etiqueta="Tipo de Processo"
                descricaoPrimaria="desTipoProcesso"
                valor="codTipoProcesso"
                :foco="false"
                :api=apiTipoProcesso
                v-model="codTipoProcesso"
              >
              </g-autocomplete>
            </div>
            <div class="col-sm-6 col-xs-6">
              <g-autocomplete
                id="refRequerente"
                name="refRequerente"
                ref="refRequerente"
                etiqueta="Requerente"
                valor="codRequerente"
                :foco="false"
                descricaoPrimaria="nomeDataNascimentoDocumento"
                :desabilitar="paginaStatus.desabilitarEdicao"
                :api="apiRequerente"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="requerente.codRequerente"
              ></g-autocomplete>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refOrgaoOrigem"
                name="refOrgaoOrigem"
                ref="refOrgaoOrigem"
                validacao="text"
                etiqueta="Órgão de Origem"
                valor="codOrgao"
                descricaoPrimaria="desOrgao"
                :api="apiOrgao"
                :foco="false"
                v-model="codOrgaoOrigem"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refUnidadeOrigem"
                name="refUnidadeOrigem"
                ref="refUnidadeOrigem"
                etiqueta="Unidade de Origem"
                valor="codUnidade"
                validacao="text"
                :foco="false"
                descricaoPrimaria="desUnidade"
                :desabilitar="desabilitarUnidadeOrigem"
                :api="apiUnidade"
                v-model="codUnidadeOrigem"
                :filtroAdicional="getFiltroUnidadeOrigem"
              ></g-autocomplete>
            </div>
            <div class="col-sm-4 col-xs-4">
              <g-autocomplete
                id="refSetorOrigem"
                name="refSetorOrigem"
                ref="refSetorOrigem"
                etiqueta="Setor de Origem"
                valor="codSetor"
                :foco="false"
                descricaoPrimaria="desSetor"
                :desabilitar="desabilitarSetorOrigem"
                :api="apiSetor"
                v-model="codSetorOrigem"
                :filtroAdicional="getFiltroSetorOrigem"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
              ></g-autocomplete>
            </div>
          </div>
        </span>
        <!-- FIM RELATÓRIO MAPA ESTATÍSTICO -->
        <!-- INÍCIO RELATÓRIO PROCESSOS INCLUÍDOS NA REMESSA -->
        <span v-if="relatorio == 'RELATORIO_PROCESSOS_INCLUIDOS_REMESSA'">
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refNumRemessaInicial"
                name="refNumRemessaInicial"
                ref="refNumRemessaInicial"
                tipo="text"
                etiqueta="Nº Remessa Inicial"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numInicialRemessa"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refNumRemessaFinal"
                name="refNumRemessaFinal"
                ref="refNumRemessaFinal"
                tipo="text"
                etiqueta="Nº Remessa Final"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numFinalRemessa"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoRemessaInicial"
                name="refAnoRemessaInicial"
                ref="refAnoRemessaInicial"
                tipo="text"
                etiqueta="Ano Remessa Inicial"
                validacao="Number"
                mascara="numero"
                :tamanho="4"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoInicialRemessa"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoRemessaFinal"
                name="refAnoRemessaFinal"
                ref="refAnoRemessaFinal"
                tipo="text"
                etiqueta="Ano Remessa Final"
                validacao="Number"
                mascara="numero"
                :tamanho="4"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoFinalRemessa"
              >
              </g-input>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refNumProcessoInicial"
                name="refNumProcessoInicial"
                ref="refNumProcessoInicial"
                tipo="text"
                etiqueta="Nº Processo Inicial"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numInicialProcesso"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refNumProcessoFinal"
                name="refNumProcessoFinal"
                ref="refNumProcessoFinal"
                tipo="text"
                etiqueta="Nº Processo Final"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numFinalProcesso"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoInicial"
                name="refAnoProcessoInicial"
                ref="refAnoProcessoInicial"
                tipo="text"
                etiqueta="Ano Processo Inicial"
                validacao="Number"
                mascara="numero"
                :tamanho="4"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoInicial"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoFinal"
                name="refAnoProcessoFinal"
                ref="refAnoProcessoFinal"
                tipo="text"
                etiqueta="Ano Processo Final"
                validacao="Number"
                mascara="numero"
                :tamanho="4"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoFinal"
              >
              </g-input>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-select
                id="refRemessa"
                name="refRemessa"
                ref="refRemessa"
                etiqueta="Status"
                :foco="false"
                :itens="statusRemessaArray"
                item-valor="codigo"
                item-etiqueta="descricao"
                :desabilitar="paginaStatus.desabilitarEdicao"
                v-model="indStatusRemessa"
              >
              </g-select>
            </div>
          </div>
        </span>
        <!-- FIM RELATÓRIO PROCESSOS INCLUÍDOS NA REMESSA -->
        <!-- INÍCIO RELATÓRIO DE REMESSAS POR PROCESSO -->
        <span v-if="relatorio == 'RELATORIO_REMESSAS_POR_PROCESSO'">
          <div class="row">
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refNumProcessoInicial"
                name="refNumProcessoInicial"
                ref="refNumProcessoInicial"
                tipo="text"
                etiqueta="Nº Processo Inicial"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numInicialProcesso"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refNumProcessoFinal"
                name="refNumProcessoFinal"
                ref="refNumProcessoFinal"
                tipo="text"
                etiqueta="Nº Processo Final"
                validacao="Number"
                mascara="numero"
                :tamanho="10"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="numFinalProcesso"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoInicial"
                name="refAnoProcessoInicial"
                ref="refAnoProcessoInicial"
                tipo="text"
                etiqueta="Ano Processo Inicial"
                validacao="Number"
                mascara="numero"
                :tamanho="4"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoInicial"
              >
              </g-input>
            </div>
            <div class="col-sm-3 col-xs-3">
              <g-input
                id="refAnoProcessoFinal"
                name="refAnoProcessoFinal"
                ref="refAnoProcessoFinal"
                tipo="text"
                etiqueta="Ano Processo Final"
                validacao="Number"
                mascara="numero"
                :tamanho="4"
                :foco="false"
                :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
                v-model="anoFinal"
              >
              </g-input>
            </div>
          </div>
        </span>
        <!-- FIM RELATÓRIO DE REMESSAS POR PROCESSO -->
        <!-- BOTÕES PESQUISAR E LIMPAR -->
        <div
          class="row mrg-t-20 text-right"
          v-if="relatorio != null && relatorio != undefined && relatorio != ''"
        >
          <div class="col-sm-6 text-left">
            <q-btn
              id="btnPesquisar"
              name="btnPesquisar"
              icon="fas fa-search"
              color="secondary"
              @click="pesquisarPrimeiraPagina"
            >&nbsp;&nbsp;Pesquisar</q-btn>&ensp;&ensp;
            <q-btn
              id="btnLimparFiltro"
              name="btnLimparFiltro"
              v-if="exibirBotoes"
              icon="fa fa-eraser"
              @click="limparFiltro"
              flat
            >&ensp;&ensp;Limpar</q-btn>
          </div>
          <div class="col-sm-6 text-right">
            <q-btn
              id="btnImprimir"
              name="btnImprimir"
              v-if="exibirBotoes"
              icon="fa fa-print"
              color="primary"
              @click="imprimir"
              flat
            >&ensp;&ensp;Imprimir</q-btn>
          </div>
        </div>
        <!-- DATA TABLE ROTEIROS DOSS PROCESSOS -->
        <div
          class="barra-vertical-400 mrg-t-10"
          v-show="exibirDataTableRoteirosDosProcessos"
        >
          <g-datatable
            id="refDataTableRoteirosDosProcessos"
            name="refDataTableRoteirosDosProcessos"
            ref="refDataTableRoteirosDosProcessos"
            :getFiltroPesquisa="getFiltroPesquisa"
            :colunas="colunasRoteirosDosProcessos"
            :api="apiRoteirosDosProcessos"
            :operacoes="operacoesRoteirosDosProcessos"
            :exibirColunaOperacoes="exibirColunaOperacoes"
            :elementosPorPagina="elementosPorPagina"
            :carregamentoInicial="false"
            :exibirTodosElementos="true"
          ></g-datatable>
        </div>
        <!-- DATA TABLE ENCAMINHAMENTO DE PROCESSO -->
        <div
          class="barra-vertical-400 mrg-t-10"
          v-show="exibirDataTableComprovanteEncaminhamento"
        >
          <g-datatable
            id="refDataTableComprovanteEncaminhamento"
            name="refDataTableComprovanteEncaminhamento"
            ref="refDataTableComprovanteEncaminhamento"
            :getFiltroPesquisa="getFiltroPesquisa"
            :colunas="colunasComprovanteEncaminhamentoProcesso"
            :api="apiComprovanteEncaminhamento"
            :operacoes="operacoesComprovanteEncaminhamento"
            :exibirColunaOperacoes="exibirColunaOperacoes"
            :elementosPorPagina="elementosPorPagina"
            :carregamentoInicial="false"
            :exibirTodosElementos="true"
          ></g-datatable>
        </div>
        <!-- DATA TABLE MOVIMENTAÇÃO DE PROCESSO -->
        <div
          class="barra-vertical-400 mrg-t-10"
          v-show="exibirDataTableComprovanteMovimentacao"
        >
          <g-datatable
            id="refDataTableComprovanteMovimentacao"
            name="refDataTableComprovanteMovimentacao"
            ref="refDataTableComprovanteMovimentacao"
            :getFiltroPesquisa="getFiltroPesquisa"
            :colunas="colunasComprovanteMovimentacaoProcesso"
            :api="apiComprovanteMovimentacao"
            :operacoes="operacoesComprovanteMovimentacao"
            :exibirColunaOperacoes="exibirColunaOperacoes"
            :elementosPorPagina="elementosPorPagina"
            :carregamentoInicial="false"
            :exibirTodosElementos="true"
          ></g-datatable>
        </div>
        <!-- DATA TABLE NOTIFICAÇÃO DE COMPARECIMENTO -->
        <div
          class="barra-vertical-400 mrg-t-10"
          v-show="exibirDataTableNotificacaoComparecimento"
        >
          <g-datatable
            id="refDataTableNotificacaoComparecimento"
            name="refDataTableNotificacaoComparecimento"
            ref="refDataTableNotificacaoComparecimento"
            :getFiltroPesquisa="getFiltroPesquisa"
            :colunas="colunasNotificacaoComparecimento"
            :api="apiNotificacaoComparecimento"
            :operacoes="operacoesNotificacaoComparecimento"
            :exibirColunaOperacoes="exibirColunaOperacoes"
            :elementosPorPagina="elementosPorPagina"
            :carregamentoInicial="false"
            :exibirTodosElementos="true"
          ></g-datatable>
        </div>
        <!-- DATA TABLE NOTIFICAÇÃO DE COMUNICADO DA SITUAÇÃO DO PROCESSO -->
        <div
          class="barra-vertical-400 mrg-t-10"
          v-show="exibirDataTableNotificacaoComunicadoSituacaoProcesso"
        >
          <g-datatable
            id="refDataTableNotificacaoComunicadoSituacaoProcesso"
            name="refDataTableNotificacaoComunicadoSituacaoProcesso"
            ref="refDataTableNotificacaoComunicadoSituacaoProcesso"
            :getFiltroPesquisa="getFiltroPesquisa"
            :colunas="colunasNotificacaoComunicadoSituacaoProcesso"
            :api="apiNotificacaoComunicadoSituacaoProcesso"
            :operacoes="operacoesNotificacaoComunicadoSituacaoProcesso"
            :exibirColunaOperacoes="exibirColunaOperacoes"
            :elementosPorPagina="elementosPorPagina"
            :carregamentoInicial="false"
            :exibirTodosElementos="true"
          ></g-datatable>
        </div>
        <!-- DATA TABLE ABERTURA GERAL DE PROCESSOS -->
        <div
          class="barra-vertical-400 mrg-t-10"
          v-show="exibirDataTableRelatorioGeralProcessos"
        >
          <g-datatable
            id="refDataTableRelatorioGeralProcessos"
            name="refDataTableRelatorioGeralProcessos"
            ref="refDataTableRelatorioGeralProcessos"
            :getFiltroPesquisa="getFiltroPesquisa"
            :colunas="colunasRelatorioGeralProcessos"
            :api="apiRelatorioGeralProcessos"
            :operacoes="operacoesRelatorioGeralProcessos"
            :exibirColunaOperacoes="exibirColunaOperacoes"
            :elementosPorPagina="elementosPorPagina"
            :carregamentoInicial="false"
            :exibirTodosElementos="true"
          ></g-datatable>
        </div>
        <!-- DATA TABLE RELATÓRIO OBSERVAÇÃO SEQUÊNCIA -->
        <div
          class="barra-vertical-400 mrg-t-10"
          v-show="exibirDataTableRelatorioObservacaoSequencia"
        >
          <g-datatable
            id="refDataTableRelatorioObservacaoSequencia"
            name="refDataTableRelatorioObservacaoSequencia"
            ref="refDataTableRelatorioObservacaoSequencia"
            :getFiltroPesquisa="getFiltroPesquisa"
            :colunas="colunasRelatorioObservacaoSequencia"
            :api="apiRelatorioObservacaoSequencia"
            :operacoes="operacoesRelatorioObservacaoSequencia"
            :exibirColunaOperacoes="exibirColunaOperacoes"
            :elementosPorPagina="elementosPorPagina"
            :carregamentoInicial="false"
            :exibirTodosElementos="true"
          ></g-datatable>
        </div>
        <!-- DATA TABLE RELATÓRIO MOVIMENTAÇÃO PROCESSOS -->
        <div
          class="barra-vertical-400 mrg-t-10"
          v-show="exibirDataTableRelatorioMovimentacaoProcessos"
        >
          <g-datatable
            id="refDataTableRelatorioMovimentacaoProcessos"
            name="refDataTableRelatorioMovimentacaoProcessos"
            ref="refDataTableRelatorioMovimentacaoProcessos"
            :getFiltroPesquisa="getFiltroPesquisa"
            :colunas="colunasRelatorioMovimentacaoProcessos"
            :api="apiRelatorioMovimentacaoProcessos"
            :operacoes="operacoesRelatorioMovimentacaoProcessos"
            :exibirColunaOperacoes="exibirColunaOperacoes"
            :elementosPorPagina="elementosPorPagina"
            :carregamentoInicial="false"
            :exibirTodosElementos="true"
          ></g-datatable>
        </div>
        <!-- DATA TABLE RELATÓRIO MAPA ESTATÍSTICO -->
        <div
          class="barra-vertical-400 mrg-t-10"
          v-show="exibirDataTableRelatorioMapaEstatistico"
        >
          <g-datatable
            id="refDataTableRelatorioMapaEstatistico"
            name="refDataTableRelatorioMapaEstatistico"
            ref="refDataTableRelatorioMapaEstatistico"
            :getFiltroPesquisa="getFiltroPesquisa"
            :colunas="colunasRelatorioMapaEstatistico"
            :api="apiRelatorioMapaEstatistico"
            :exibirColunaOperacoes="false"
            :elementosPorPagina="elementosPorPagina"
            :carregamentoInicial="false"
            :exibirTodosElementos="true"
          ></g-datatable>
        </div>
        <!-- DATA TABLE RELATÓRIO DE PROCESSOS INCLUÍDOS NA REMESSA -->
        <div
          class="barra-vertical-400 mrg-t-10"
          v-show="exibirDataTableRelatorioProcessosIncluidosRemessa"
        >
          <g-datatable
            id="refDataTableRelatorioProcessosIncluidosRemessa"
            name="refDataTableRelatorioProcessosIncluidosRemessa"
            ref="refDataTableRelatorioProcessosIncluidosRemessa"
            :getFiltroPesquisa="getFiltroPesquisa"
            :colunas="colunasRelatorioProcessosIncluidosRemessa"
            :api="apiRelatorioProcessosIncluidosRemessa"
            :operacoes="operacoesRelatorioProcessosIncluidosRemessa"
            :exibirColunaOperacoes="false"
            :elementosPorPagina="elementosPorPagina"
            :carregamentoInicial="false"
            :exibirTodosElementos="true"
          ></g-datatable>
        </div>
        <!-- DATA TABLE RELATÓRIO DE REMESSAS -->
        <div
          class="barra-vertical-400 mrg-t-10"
          v-show="exibirDataTableRelatorioRemessas"
        >
          <g-datatable
            id="refDataTableRelatorioRemessasPorProcesso"
            name="refDataTableRelatorioRemessasPorProcesso"
            ref="refDataTableRelatorioRemessasPorProcesso"
            :getFiltroPesquisa="getFiltroPesquisa"
            :colunas="colunasRelatorioRemessasPorProcesso"
            :api="apiRelatorioRemessas"
            :operacoes="operacoesRelatorioRemessasPorProcesso"
            :exibirColunaOperacoes="true"
            :elementosPorPagina="elementosPorPagina"
            :carregamentoInicial="false"
            :exibirTodosElementos="true"
          ></g-datatable>
        </div>
      </q-card-main>
    </q-card>
  </div>
</template>

<script>
import api from 'components/util/api'
import GInput from 'components/util/gInput'
import GPesquisa from 'components/util/gPesquisa'
import GBreadcrumb from 'components/util/gBreadcrumb'
import GAutocomplete from 'components/util/gAutocomplete'
import util from 'components/util/util'
import utilHttp from 'components/util/utilHttp'
// import GDatepicker from 'components/util/gDatepicker'
import GSelect from 'components/util/gSelect'
import GDatatable from 'components/util/gDatatable'
import GDateInput from 'components/util/gDateInput'

export default {
  data () {
    return {
      relatorio: '',
      apiComprovanteEncaminhamento: api.COMPROVANTE_ENCAMINHAMENTO,
      apiComprovanteMovimentacao: api.COMPROVANTE_MOVIMENTACAO_PROCESSO,
      apiNotificacaoComparecimento: api.NOTIFICACAO_SOLICITACAO_COMPARECIMENTO,
      apiNotificacaoComunicadoSituacaoProcesso: api.NOTIFICACAO_COMUNICADO_SITUACAO_PROCESSO,
      apiRelatorioGeralProcessos: api.RELATORIO_GERAL_PROCESSOS,
      apiRoteirosDosProcessos: api.RELATORIO_ROTEIROS_DOS_PROCESSOS,
      apiRelatorioObservacaoSequencia: api.RELATORIO_OBSERVACAO_SEQUENCIA,
      apiRelatorioMovimentacaoProcessos: api.RELATORIO_MOVIMENTACAO_PROCESSOS_GERAL,
      apiRelatorioMapaEstatistico: api.RELATORIO_MAPA_ESTATISTICO,
      apiRelatorioProcessosIncluidosRemessa: api.RELATORIO_PROCESSOS_INCLUIDOS_REMESSA,
      apiRelatorioRemessas: api.RELATORIO_REMESSAS_POR_PROCESSO,
      apiRelatorioLegadoCrystal: api.RELATORIO_CRYSTAL,
      apiTipoProcesso: api.TIPO_DE_PROCESSO_DESCRICAO,
      apiAssunto: api.ASSUNTO,
      apiSubAssunto: api.SUB_ASSUNTO_COD_ASSUNTO,
      apiImprimirRelatorio: '',
      apiOrgao: api.ORGAO,
      apiUnidade: api.BUSCAR_UNIDADE_ORGAO,
      apiSetor: api.SETOR_UNIDADE,
      apiRequerente: api.REQUERENTE,
      apiUsuario: api.RESPONSAVEL_SETOR,
      anoInicial: '',
      anoFinal: '',
      codRepresentante: '',
      indStatusProcesso: '',
      numInicialProcesso: '',
      numFinalProcesso: '',
      dataInicial: '',
      dataFinal: '',
      comprovante: '',
      codOrgaoOrigem: '',
      codOrgaoDestino: '',
      codUnidadeOrigem: '',
      codUnidadeDestino: '',
      codSetorOrigem: '',
      codSetorDestino: '',
      codTipoProcesso: '',
      codAssunto: '',
      codSubassunto: '',
      elementosPorPagina: 500,
      tipoComprovante: '',
      local: '',
      desabilitarOrgaoOrigem: '',
      desabilitarSetorOrigem: '',
      desabilitarUnidadeOrigem: '',
      desabilitarSetorDestino: '',
      desabilitarUnidadeDestino: '',
      desabilitarAssunto: '',
      desabilitarSubAssunto: '',
      exibirDataTableComprovanteMovimentacao: '',
      exibirDataTableComprovanteEncaminhamento: '',
      exibirDataTableNotificacaoComparecimento: '',
      exibirDataTableNotificacaoComunicadoSituacaoProcesso: '',
      exibirDataTableRelatorioGeralProcessos: '',
      exibirDataTableRoteirosDosProcessos: '',
      exibirDataTableRelatorioObservacaoSequencia: '',
      exibirDataTableRelatorioMovimentacaoProcessos: '',
      exibirDataTableRelatorioMapaEstatistico: '',
      exibirDataTableRelatorioProcessosIncluidosRemessa: '',
      exibirDataTableRelatorioRemessas: '',
      exibirColunaOperacoes: true,
      exibirBotoes: '',
      indStatusRemessa: '',
      numInicialRemessa: '',
      numFinalRemessa: '',
      anoInicialRemessa: '',
      anoFinalRemessa: '',
      nomeComprovanteAbertura: '',
      nomeComprovanteMovimento: '',
      dtInicial: '',
      dtFinal: '',
      codUsuarioResponsavelAbertura: '',
      requerente: {},
      paginaStatus: {
        caminhoMigalha: [
          {
            icone: '',
            descricao: '',
            rotaNome: ''
          }
        ]
      },
      statusProcessoArray: [{ codigo: 'TOD', descricao: 'TODOS' }, { codigo: 'ABE', descricao: 'ABERTO' }, { codigo: 'MOV', descricao: 'MOVIMENTADO' }, { codigo: 'CON', descricao: 'CONFIRMADO' }, { codigo: 'ENC', descricao: 'ENCERRADO' }, { codigo: 'ARQ', descricao: 'ARQUIVADO' }, { codigo: 'CAN', descricao: 'CANCELADO' }],
      statusProcessoSemConfirmadoArray: [{ codigo: 'TOD', descricao: 'TODOS' }, { codigo: 'ABE', descricao: 'ABERTO' }, { codigo: 'MOV', descricao: 'MOVIMENTADO' }, { codigo: 'ENC', descricao: 'ENCERRADO' }, { codigo: 'ARQ', descricao: 'ARQUIVADO' }, { codigo: 'CAN', descricao: 'CANCELADO' }],
      statusRemessaArray: [{ codigo: 'TOD', descricao: 'TODOS' }, { codigo: 'MOV', descricao: 'MOVIMENTADO' }, { codigo: 'FIN', descricao: 'FINALIZADO' }],

      colunasRoteirosDosProcessos: [
        {
          conteudoTipo: 'checkBox',
          largura: '4%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'checkBox',
          conteudoClasse: 'text-left'
        },
        {
          conteudoTipo: '',
          largura: '25%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Tipo de Processo',
          conteudoClasse: 'text-left',
          propriedade: 'tipoProcesso.desTipoProcesso' // é o dado que vai aparecer na minha tela (mesmo nome do back)
        },
        {
          conteudoTipo: '',
          largura: '28%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Assunto',
          conteudoClasse: 'text-left',
          propriedade: 'subassunto.assunto.desAssunto'
        },
        {
          conteudoTipo: '',
          largura: '28%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Subassunto',
          conteudoClasse: 'text-left',
          propriedade: 'subassunto.desSubassunto'
        },
        {
          conteudoTipo: '',
          largura: '5%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Rota',
          conteudoClasse: 'text-left',
          propriedade: 'numRota'
        }
      ],

      colunasComprovanteMovimentacaoProcesso: [
        {
          conteudoTipo: 'checkBox',
          largura: '4%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'checkBox',
          conteudoClasse: 'text-left'
        },
        {
          conteudoTipo: '',
          largura: '8%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Processo',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.numProcesso',
          chave: 'numProcesso'
        },
        {
          conteudoTipo: '',
          largura: '8%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Sequência',
          conteudoClasse: 'text-left',
          propriedade: 'numSequencia'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Data de Abertura',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.datProcesso',
          formatar: valor => util.formatarData(valor, 'dd/mm/yyyy')
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Status',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.indStatusProcesso',
          formatar: valor => this.formatarStatus(valor)
        },
        {
          conteudoTipo: '',
          largura: '40%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Requerente',
          conteudoClasse: 'text-left',
          propriedade: 'aberturaProcesso.requerente.nomeDataNascimentoDocumento'
        }
      ],
      colunasComprovanteEncaminhamentoProcesso: [
        {
          conteudoTipo: 'checkBox',
          largura: '4%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'checkBox',
          conteudoClasse: 'text-left'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Processo',
          conteudoClasse: 'text-left',
          propriedade: 'numProcesso',
          chave: 'numProcesso'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Data de Abertura',
          conteudoClasse: 'text-left',
          propriedade: 'datProcesso',
          formatar: valor => util.formatarData(valor, 'dd/mm/yyyy')
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Status',
          conteudoClasse: 'text-left',
          propriedade: 'indStatusProcesso',
          formatar: valor => this.formatarStatus(valor)
        },
        {
          conteudoTipo: '',
          largura: '40%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Requerente',
          conteudoClasse: 'text-left',
          propriedade: 'requerente.nomeDataNascimentoDocumento'
        }
      ],
      colunasNotificacaoComparecimento: [
        {
          conteudoTipo: 'checkBox',
          largura: '4%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'checkBox',
          conteudoClasse: 'text-left'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Processo',
          conteudoClasse: 'text-left',
          propriedade: 'numProcesso',
          chave: 'numProcesso'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Data de Abertura',
          conteudoClasse: 'text-left',
          propriedade: 'datProcesso',
          formatar: valor => util.formatarData(valor, 'dd/mm/yyyy')
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Status',
          conteudoClasse: 'text-left',
          propriedade: 'indStatusProcesso',
          formatar: valor => this.formatarStatus(valor)
        },
        {
          conteudoTipo: '',
          largura: '40%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Requerente',
          conteudoClasse: 'text-left',
          propriedade: 'requerente.nomeDataNascimentoDocumento'
        }
      ],
      colunasNotificacaoComunicadoSituacaoProcesso: [
        {
          conteudoTipo: 'checkBox',
          largura: '4%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'checkBox',
          conteudoClasse: 'text-left'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Processo',
          conteudoClasse: 'text-left',
          propriedade: 'numProcesso',
          chave: 'numProcesso'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Data de Abertura',
          conteudoClasse: 'text-left',
          propriedade: 'datProcesso',
          formatar: valor => util.formatarData(valor, 'dd/mm/yyyy')
        },
        {
          conteudoTipo: '',
          largura: '40%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Requerente',
          conteudoClasse: 'text-left',
          propriedade: 'requerente.nomeDataNascimentoDocumento'
        }
      ],
      colunasRelatorioGeralProcessos: [
        {
          conteudoTipo: 'checkBox',
          largura: '4%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'checkBox',
          conteudoClasse: 'text-left'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Processo',
          conteudoClasse: 'text-left',
          propriedade: 'numProcesso',
          chave: 'numProcesso'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Data de Abertura',
          conteudoClasse: 'text-left',
          propriedade: 'datProcesso',
          formatar: valor => util.formatarData(valor, 'dd/mm/yyyy')
        },
        {
          conteudoTipo: '',
          largura: '40%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Requerente',
          conteudoClasse: 'text-left',
          propriedade: 'requerente.nomeDataNascimentoDocumento'
        }
      ],
      colunasRelatorioObservacaoSequencia: [
        {
          conteudoTipo: 'checkBox',
          largura: '4%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'checkBox',
          conteudoClasse: 'text-left'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Processo',
          conteudoClasse: 'text-left',
          propriedade: 'numProcesso',
          chave: 'numProcesso'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Data de Abertura',
          conteudoClasse: 'text-left',
          propriedade: 'datProcesso',
          formatar: valor => util.formatarData(valor, 'dd/mm/yyyy')
        },
        {
          conteudoTipo: '',
          largura: '40%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Requerente',
          conteudoClasse: 'text-left',
          propriedade: 'requerente.nomeDataNascimentoDocumento'
        }
      ],
      colunasRelatorioMovimentacaoProcessos: [
        {
          conteudoTipo: 'checkBox',
          largura: '4%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'checkBox',
          conteudoClasse: 'text-left'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Processo',
          conteudoClasse: 'text-left',
          propriedade: 'numProcesso',
          chave: 'numProcesso'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Data de Abertura',
          conteudoClasse: 'text-left',
          propriedade: 'datProcesso',
          formatar: valor => util.formatarData(valor, 'dd/mm/yyyy')
        },
        {
          conteudoTipo: '',
          largura: '40%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Requerente',
          conteudoClasse: 'text-left',
          propriedade: 'requerente.nomeDataNascimentoDocumento'
        }
      ],
      colunasRelatorioMapaEstatistico: [
        {
          conteudoTipo: '',
          largura: '8%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Processo',
          conteudoClasse: 'text-left',
          propriedade: 'numProcesso',
          chave: 'numProcesso'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Data de Abertura',
          conteudoClasse: 'text-left',
          propriedade: 'datProcesso',
          formatar: valor => util.formatarData(valor, 'dd/mm/yyyy')
        },
        {
          conteudoTipo: '',
          largura: '40%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Requerente',
          conteudoClasse: 'text-left',
          propriedade: 'requerente.nomeDataNascimentoDocumento'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Tipo Processo',
          conteudoClasse: 'text-left',
          propriedade: 'tipoProcesso.desTipoProcesso'
        }
      ],
      colunasRelatorioProcessosIncluidosRemessa: [
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Remessa',
          conteudoClasse: 'text-left',
          propriedade: 'numRemessa',
          chave: 'numRemessa'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Ano Remessa',
          conteudoClasse: 'text-left',
          propriedade: 'anoRemessa'
        },
        {
          conteudoTipo: '',
          largura: '15%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Processo',
          conteudoClasse: 'text-left',
          propriedade: 'movimentacaoProcesso.aberturaProcesso.numProcesso'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Ano Processo',
          conteudoClasse: 'text-left',
          propriedade: 'movimentacaoProcesso.aberturaProcesso.anoProcesso'
        },
        {
          conteudoTipo: '',
          largura: '20%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Status',
          conteudoClasse: 'text-left',
          propriedade: 'indStatusRemessa',
          chave: 'indStatusRemessa'
        }
      ],
      colunasRelatorioRemessasPorProcesso: [
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Processo',
          conteudoClasse: 'text-left',
          propriedade: 'movimentacaoProcesso.aberturaProcesso.numProcesso'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Ano Processo',
          conteudoClasse: 'text-left',
          propriedade: 'movimentacaoProcesso.aberturaProcesso.anoProcesso'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Nº Remessa',
          conteudoClasse: 'text-left',
          propriedade: 'numRemessa',
          chave: 'numRemessa'
        },
        {
          conteudoTipo: '',
          largura: '10%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Ano Remessa',
          conteudoClasse: 'text-left',
          propriedade: 'anoRemessa'
        },
        {
          conteudoTipo: '',
          largura: '20%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Status',
          conteudoClasse: 'text-left',
          propriedade: 'indStatusRemessa'
        }
      ],
      operacoesRoteirosDosProcessos: [
        {
          cor: 'black',
          icone: 'fas fa-print',
          tooltip: 'Imprimir',
          clique: this.imprimirLinhaSelecionadaLegadoCrystal,
          permissao: row => true,
          visivel: row => true
        }
      ],
      operacoesComprovanteEncaminhamento: [
        {
          cor: 'black',
          icone: 'fas fa-print',
          tooltip: 'Imprimir',
          clique: this.imprimirLinhaSelecionada,
          permissao: row => true,
          visivel: row => true
        }
      ],
      operacoesComprovanteMovimentacao: [
        {
          cor: 'black',
          icone: 'fas fa-print',
          tooltip: 'Imprimir',
          clique: this.imprimirLinhaSelecionada,
          permissao: row => true,
          visivel: row => true
        }
      ],
      operacoesNotificacaoComparecimento: [
        {
          cor: 'black',
          icone: 'fas fa-print',
          tooltip: 'Imprimir',
          clique: this.imprimirLinhaSelecionada,
          permissao: row => true,
          visivel: row => true
        }
      ],
      operacoesNotificacaoComunicadoSituacaoProcesso: [
        {
          cor: 'black',
          icone: 'fas fa-print',
          tooltip: 'Imprimir',
          clique: this.imprimirLinhaSelecionada,
          permissao: row => true,
          visivel: row => true
        }
      ],
      operacoesRelatorioGeralProcessos: [
        {
          cor: 'black',
          icone: 'fas fa-print',
          tooltip: 'Imprimir',
          clique: this.imprimirLinhaSelecionada,
          permissao: row => true,
          visivel: row => true
        }
      ],
      operacoesRelatorioObservacaoSequencia: [
        {
          cor: 'black',
          icone: 'fas fa-print',
          tooltip: 'Imprimir',
          clique: this.imprimirLinhaSelecionada,
          permissao: row => true,
          visivel: row => true
        }
      ],
      operacoesRelatorioMovimentacaoProcessos: [
        {
          cor: 'black',
          icone: 'fas fa-print',
          tooltip: 'Imprimir',
          clique: this.imprimirLinhaSelecionadaLegadoCrystal,
          permissao: row => true,
          visivel: row => true
        }
      ],
      operacoesRelatorioProcessosIncluidosRemessa: [
        {
          cor: 'black',
          icone: 'fas fa-print',
          tooltip: 'Imprimir',
          clique: this.imprimirLinhaSelecionada,
          permissao: row => true,
          visivel: row => true
        }
      ],
      operacoesRelatorioRemessasPorProcesso: [
        {
          cor: 'green',
          icone: 'fas fa-check',
          tooltip: 'Movimentado',
          permissao: (row) => true,
          visivel: (row) => this.habilitarConfirmacaoRemessaProcesso(row)
        },
        {
          cor: 'blue',
          icone: 'fas fa-search',
          tooltip: 'Visualizar Remessa',
          clique: this.visualizarRemessa,
          permissao: (row) => true,
          visivel: (row) => true
        }
      ],
      relatoriosArray: [
        {
          codigo: 'RELATORIO_REMESSAS_POR_PROCESSO',
          descricao: 'Remessas por Processo'
        },
        {
          codigo: 'RELATORIO_PROCESSOS_INCLUIDOS_REMESSA',
          descricao: 'Processos Incluídos na Remessa'
        },
        {
          codigo: 'RELATORIO_MAPA_ESTATISTICO',
          descricao: 'Mapa Estatístico'
        },
        {
          codigo: 'RELATORIO_OBSERVACAO_SEQUENCIA',
          descricao: 'Observações por Sequência'
        },
        {
          codigo: 'RELATORIO_MOVIMENTACAO_PROCESSOS',
          descricao: 'Movimentações dos Processos'
        },
        {
          codigo: 'RELATORIO_GERAL_PROCESSOS',
          descricao: 'Geral de Processos'
        },
        {
          codigo: 'NOTIFICACAO_COMUNICADO_SITUACAO_PROCESSO',
          descricao: 'Notificação de Comunicado de Situação de Processo'
        },
        {
          codigo: 'NOTIFICACAO_SOLICITACAO_COMPARECIMENTO',
          descricao: 'Notificação de Solicitação de Comparecimento'
        },
        {
          codigo: 'COMPROVANTE_ENCAMINHAMENTO_PROCESSO',
          descricao: 'Comprovante de Encaminhamento de Processo'
        },
        {
          codigo: 'COMPROVANTE_MOVIMENTACAO_PROCESSO',
          descricao: 'Comprovante de Movimentação de Processo'
        },
        {
          codigo: 'ROTEIROS_DOS_PROCESSOS',
          descricao: 'Roteiros dos Processos'
        }
      ]
    }
  },
  methods: {
    visualizarRemessa (item) {
      var newPaginaStatus = {
        remessaProcesso: {
          movimentacaoProcesso: {
            situacao: {},
            responsavelMovimento: { usuario: {} },
            responsavelConfirmacao: { usuario: {} },
            setor: { unidade: { orgao: {} } },
            setorConfirmacao: { unidade: { orgao: {} } },
            aberturaProcesso: {
              responsavel: { usuario: {} },
              representante: { usuario: {} },
              formaSolicitacao: {},
              tipoProcesso: {},
              subassunto: { assunto: {} },
              roteiro: { setor: { unidade: { orgao: {} } } },
              requerente: {},
              justificativa: {}
            }
          }
        }
      }
      newPaginaStatus.operacao = {
        descricao: 'Visualizar Remessa',
        icone: 'fa fa-search'
      }
      newPaginaStatus.caminhoMigalha = this.paginaStatus.caminhoMigalha
      newPaginaStatus.desabilitarEdicao = true
      var filtro = ''
        .concat('?numRemessa=').concat(item.numRemessa)
        .concat('&anoRemessa=').concat(item.anoRemessa)
      utilHttp.httpGet(api.BUSCAR_REMESSA_PROCESSO_A_CONFIRMAR.concat(filtro), resposta => {
        newPaginaStatus.remessaProcesso = resposta.body
        this.$router.push({
          name: 'remessaProcessoConfirmacao',
          params: {
            paginaStatus: newPaginaStatus
          }
        })
      })
    },
    habilitarConfirmacaoRemessaProcesso (item) {
      var existe = false
      if (item.indStatusRemessa === 'Movimentado') {
        existe = true
      }
      return existe
    },

    changeOrgaoOrigem () {
      var self = this
      self.codSetorOrigem = ''
      self.codUnidadeOrigem = ''
      if (self.$refs['refUnidadeOrigem'] !== undefined) { self.$refs['refUnidadeOrigem'].limpar() }
      if (self.$refs['refSetorOrigem'] !== undefined) { self.$refs['refSetorOrigem'].limpar() }
    },
    changeUnidadeOrigem () {
      var self = this
      self.codSetorOrigem = ''
      if (self.$refs['refSetorOrigem'] !== undefined) { self.$refs['refSetorOrigem'].limpar() }
    },
    changeOrgaoDestino () {
      var self = this
      self.codSetorDestino = ''
      self.codUnidadeDestino = ''
      if (self.$refs['refUnidadeDestino'] !== undefined) { self.$refs['refUnidadeDestino'].limpar() }
      if (self.$refs['refSetorDestino'] !== undefined) { self.$refs['refSetorDestino'].limpar() }
    },
    changeUnidadeDestino () {
      var self = this
      self.codSetorDestino = ''
      if (self.$refs['refSetorDestino'] !== undefined) { self.$refs['refSetorDestino'].limpar() }
    },
    changeTipoProcesso () {
      var self = this
      self.codAssunto = ''
      self.codSubassunto = ''
      if (self.$refs['refAssunto'] !== undefined) { self.$refs['refAssunto'].limpar() }
      if (self.$refs['refSubAssunto'] !== undefined) { self.$refs['refSubAssunto'].limpar() }
    },
    changeAssunto () {
      var self = this
      self.codSubassunto = ''
      if (self.$refs['refSubAssunto'] !== undefined) { self.$refs['refSubAssunto'].limpar() }
    },
    buscarParametroSistema () {
      var self = this

      utilHttp.httpGet(api.PARAMETROS_SISTEMA, resposta => {
        if (resposta.body !== undefined && resposta.body !== '') {
          self.parametrosSistema = resposta.body
          self.nomeComprovanteAbertura = self.parametrosSistema.nomComprovanteEncaminhamento
          self.nomeComprovanteMovimento = self.parametrosSistema.nomComprovanteMovimento
        } else {
          self.nomeComprovanteAbertura = 'RelatorioComprovanteEncaminhamento'
          self.nomeComprovanteMovimento = 'RelatorioComprovanteMovimentaçãoProcesso'
        }
      })
    },
    imprimir () {
      var self = this
      var str = ''
      var codTipoProcesso = ''
      var codSubassunto = ''
      var numRota = ''
      let url = ''

      // ROTEIROS DOS PROCESSOS
      if (self.relatorio === 'ROTEIROS_DOS_PROCESSOS') {
        let dadosSelecionados = self.$refs['refDataTableRoteirosDosProcessos'].getDadosSelecionadosCheckbox()
        url = this.apiImprimirRelatorio
        if (dadosSelecionados.length > 0) {
          dadosSelecionados.forEach(d => {
            if (d !== undefined && d != null && d !== '') {
              codTipoProcesso = codTipoProcesso.concat(d.tipoProcesso.codTipoProcesso.toString()).concat(',')
              codSubassunto = codSubassunto.concat(d.subassunto.codSubassunto.toString()).concat(',')
              numRota = numRota.concat(d.numRota.toString()).concat(',')
            }
          })
        }
        if (codTipoProcesso !== '') {
          codTipoProcesso = codTipoProcesso.substring(0, codTipoProcesso.length - 1)
          codSubassunto = codSubassunto.substring(0, codSubassunto.length - 1)
          numRota = numRota.substring(0, numRota.length - 1)
          url = url.concat('?codTipoProcesso=').concat(codTipoProcesso.toString())
          url = url.concat('&codSubassunto=').concat(codSubassunto.toString())
          url = url.concat('&numRota=').concat(numRota.toString())
          url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
          str = url
        }
      }

      // RELATÓRIO DE REMESSAS
      if (self.relatorio === 'RELATORIO_REMESSAS_POR_PROCESSO') {
        let dadosSelecionados = self.$refs['refDataTableRelatorioRemessasPorProcesso'].getDados()
        url = this.apiImprimirRelatorio.concat('?codProcesso=')

        if (dadosSelecionados.length > 0) {
          dadosSelecionados.forEach(d => {
            if (d !== undefined && d != null && d !== '') {
              str = str.concat(d.movimentacaoProcesso.aberturaProcesso.codProcesso.toString()).concat(',')
            }
          })
        }
        if (str !== '') {
          str = str.substring(0, str.length - 1)
          url = url.concat(str.toString())
          url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
        }
      }
      // RELATÓRIO PROCESSOS INCLUÍDOS NA REMESSA
      if (self.relatorio === 'RELATORIO_PROCESSOS_INCLUIDOS_REMESSA') {
        let dadosSelecionados = self.$refs['refDataTableRelatorioProcessosIncluidosRemessa'].getDados()
        url = this.apiImprimirRelatorio.concat('?codRemessa=')
        if (dadosSelecionados.length > 0) {
          dadosSelecionados.forEach(d => {
            if (d !== undefined && d != null && d !== '') {
              str = str.concat(d.codRemessa.toString()).concat(',')
            }
          })
        }
        if (str !== '') {
          str = str.substring(0, str.length - 1)
          url = url.concat(str.toString())
          url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
        }
      }
      // RELATÓRIO MAPA ESTATÍSTICO
      if (self.relatorio === 'RELATORIO_MAPA_ESTATISTICO') {
        // var dadosSelecionados = self.$refs['refDataTableRelatorioMapaEstatistico'].getDados()

        url = this.apiImprimirRelatorio
        // url = url.concat('?codProcesso=')
        // if (dadosSelecionados.length > 0) {
        //   dadosSelecionados.forEach(d => {
        //     if (d !== undefined && d != null && d !== '') {
        //       str = str.concat(d.codProcesso.toString()).concat(',')
        //     }
        //   })
        // }

        // if (str !== '') {
        if (self.numInicialProcesso) {
          url = url.concat('?numInicialProcesso=').concat(self.numInicialProcesso)
        } else {
          url = url.concat('?numInicialProcesso=').concat('')
        }
        if (self.numFinalProcesso) {
          url = url.concat('&numFinalProcesso=').concat(self.numFinalProcesso)
        } else {
          url = url.concat('&numFinalProcesso=').concat('')
        }
        if (self.anoInicial) {
          url = url.concat('&anoProcesso=').concat(self.anoInicial)
        } else {
          url = url.concat('&anoProcesso=').concat('')
        }
        if (self.anoFinal) {
          url = url.concat('&anoProcessoFinal=').concat(self.anoFinal)
        } else {
          url = url.concat('&anoProcessoFinal=').concat('')
        }
        if (self.requerente.codRequerente !== undefined && self.requerente.codRequerente !== '' && self.requerente.codRequerente !== null) {
          url = url.concat('&codRequerente=').concat(self.requerente.codRequerente)
        } else {
          url = url.concat('&codRequerente=').concat('')
        }
        if (self.codTipoProcesso) {
          url = url.concat('&codTipoProcesso=').concat(self.codTipoProcesso)
        } else {
          url = url.concat('&codTipoProcesso=').concat('')
        }
        if (self.codOrgaoOrigem) {
          url = url.concat('&codOrgaoOrigem=').concat(self.codOrgaoOrigem)
        } else {
          url = url.concat('&codOrgaoOrigem=').concat('')
        }
        if (self.codUnidadeOrigem) {
          url = url.concat('&codUnidadeOrigem=').concat(self.codUnidadeOrigem)
        } else {
          url = url.concat('&codUnidadeOrigem=').concat('')
        }
        if (self.codSetorOrigem) {
          url = url.concat('&codSetorOrigem=').concat(self.codSetorOrigem)
        } else {
          url = url.concat('&codSetorOrigem=').concat('')
        }
        str = str.substring(0, str.length - 1)
        url = url.concat(str.toString())
        url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
        // }

        // NOME DO REQUERENTE
        if (self.requerente.codRequerente !== undefined && self.requerente.codRequerente !== '' && self.requerente.codRequerente !== null) {
          url = url.concat('&nomRequerente=').concat(self.$refs['refRequerente'].objetoSelecionado.nomRequerente)
        }
        // DESCRIÇÃO DO TIPO DE PROCESSO
        if (self.codTipoProcesso !== undefined && self.codTipoProcesso !== '' && self.codTipoProcesso !== null) {
          url = url.concat('&desTipoProcesso=').concat(self.$refs['refTipoProcesso'].objetoSelecionado.desTipoProcesso)
        }
        // ÓRGÃO
        if (self.codOrgaoOrigem !== undefined && self.codOrgaoOrigem !== '' && self.codOrgaoOrigem !== null) {
          url = url.concat('&desOrgao=').concat(self.$refs['refOrgaoOrigem'].objetoSelecionado.desOrgao)
        }
        // UNIDADE
        if (self.codUnidadeOrigem !== undefined && self.codUnidadeOrigem !== '' && self.codUnidadeOrigem !== null) {
          url = url.concat('&desUnidade=').concat(self.$refs['refUnidadeOrigem'].objetoSelecionado.desUnidade)
        }
        // SETOR
        if (self.codSetorOrigem !== undefined && self.codSetorOrigem !== '' && self.codSetorOrigem !== null) {
          url = url.concat('&desSetor=').concat(self.$refs['refSetorOrigem'].objetoSelecionado.desSetor)
        }
      }
      // RELATÓRIO DE OBSERVAÇÃO POR SEQUÊNCIA
      if (self.relatorio === 'RELATORIO_OBSERVACAO_SEQUENCIA') {
        let dadosSelecionados = self.$refs['refDataTableRelatorioObservacaoSequencia'].getDadosSelecionadosCheckbox()
        url = this.apiImprimirRelatorio.concat('?codProcesso=')
        if (dadosSelecionados.length > 0) {
          dadosSelecionados.forEach(d => {
            if (d !== undefined && d != null && d !== '') {
              str = str.concat(d.codProcesso.toString()).concat(',')
            }
          })
        }
        if (str !== '') {
          str = str.substring(0, str.length - 1)
          url = url.concat(str.toString())
          url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
        }
      }
      // RELATÓRIO DE MOVIMENTAÇÃO DOS PROCESSOS
      if (self.relatorio === 'RELATORIO_MOVIMENTACAO_PROCESSOS') {
        let dadosSelecionados = self.$refs['refDataTableRelatorioMovimentacaoProcessos'].getDadosSelecionadosCheckbox()
        url = this.apiImprimirRelatorio.concat('?codProcesso=')
        if (dadosSelecionados.length > 0) {
          dadosSelecionados.forEach(d => {
            if (d !== undefined && d != null && d !== '') {
              str = str.concat(d.codProcesso.toString()).concat(',')
            }
          })
        }
        if (str !== '') {
          str = str.substring(0, str.length - 1)
          url = url.concat(str.toString())
          url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
        }
      }
      // RELATÓRIO GERAL DE PROCESSOS
      if (self.relatorio === 'RELATORIO_GERAL_PROCESSOS') {
        let dadosSelecionados = self.$refs['refDataTableRelatorioGeralProcessos'].getDadosSelecionadosCheckbox()
        url = this.apiImprimirRelatorio.concat('?codProcesso=')
        if (dadosSelecionados.length > 0) {
          dadosSelecionados.forEach(d => {
            if (d !== undefined && d != null && d !== '') {
              str = str.concat(d.codProcesso.toString()).concat(',')
            }
          })
        }
        if (str !== '') {
          str = str.substring(0, str.length - 1)
          url = url.concat(str.toString())
          url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
        }
      }
      // COMPROVANTE DE ENCAMINHAMENTO DE PROCESSO
      if (self.relatorio === 'COMPROVANTE_ENCAMINHAMENTO_PROCESSO') {
        let dadosSelecionados = self.$refs['refDataTableComprovanteEncaminhamento'].getDadosSelecionadosCheckbox()
        url = this.apiImprimirRelatorio.concat('?codProcesso=')

        if (dadosSelecionados.length > 0) {
          dadosSelecionados.forEach(d => {
            if (d !== undefined && d != null && d !== '') {
              str = str.concat(d.codProcesso.toString()).concat(',')
            }
          })
        }
        if (str !== '') {
          str = str.substring(0, str.length - 1)
          url = url.concat(str.toString())
          url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
          url = url.concat('&nomComprovanteEncaminhamento=').concat(self.parametrosSistema.nomComprovanteEncaminhamento)
        }
      }
      // COMPROVANTE DE MOVIMENTAÇÃO DE PROCESSO
      if (self.relatorio === 'COMPROVANTE_MOVIMENTACAO_PROCESSO') {
        let dadosSelecionados = self.$refs['refDataTableComprovanteMovimentacao'].getDadosSelecionadosCheckbox()
        url = this.apiImprimirRelatorio.concat('?codMovimentacao=')
        if (dadosSelecionados.length > 0) {
          dadosSelecionados.forEach(d => {
            if (d !== undefined && d != null && d !== '') {
              str = str.concat(d.codMovimentacao.toString()).concat(',')
            }
          })
        }
        if (str !== '') {
          str = str.substring(0, str.length - 1)
          url = url.concat(str.toString())
          url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
          url = url.concat('&nomComprovanteMovimento=').concat(self.parametrosSistema.nomComprovanteMovimento)
        }
      }
      // COMPROVANTE DE NOTIFICAÇÃO DE SOLICICAÇÃO DE COMPARECIMENTO
      if (self.relatorio === 'NOTIFICACAO_SOLICITACAO_COMPARECIMENTO') {
        let dadosSelecionados = self.$refs['refDataTableNotificacaoComparecimento'].getDadosSelecionadosCheckbox()
        url = this.apiImprimirRelatorio.concat('?codProcesso=')
        if (dadosSelecionados.length > 0) {
          dadosSelecionados.forEach(d => {
            if (d !== undefined && d != null && d !== '') {
              str = str.concat(d.codProcesso.toString()).concat(',')
            }
          })
        }
        if (str !== '') {
          str = str.substring(0, str.length - 1)
          url = url.concat(str.toString())
          url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
        }
      }
      // COMPROVANTE DE NOTIFICAÇÃO DE COMUNICADO DA SITUAÇÃO DO PROCESSO
      if (self.relatorio === 'NOTIFICACAO_COMUNICADO_SITUACAO_PROCESSO') {
        let dadosSelecionados = self.$refs['refDataTableNotificacaoComunicadoSituacaoProcesso'].getDadosSelecionadosCheckbox()
        url = this.apiImprimirRelatorio.concat('?codProcesso=')
        if (dadosSelecionados.length > 0) {
          dadosSelecionados.forEach(d => {
            if (d !== undefined && d != null && d !== '') {
              str = str.concat(d.codProcesso.toString()).concat(',')
            }
          })
        }
        if (str !== '') {
          str = str.substring(0, str.length - 1)
          url = url.concat(str.toString())
          url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
        }
      }

      if (self.relatorio !== 'RELATORIO_MAPA_ESTATISTICO') {
        if (str !== '') {
          utilHttp.httpGet(url, resposta => {
            window.open(url)
          })
        } else {
          util.exibirToastInfo('Selecione pelo menos um item')
        }
      } else {
        utilHttp.httpGet(url, resposta => {
          window.open(url)
        })
      }
    },
    imprimirLinhaSelecionada (item) {
      var self = this
      let url = ''

      // ROTEIROS DOS PROCESSOS
      if (self.relatorio === 'ROTEIROS_DOS_PROCESSOS') {
        url = self.apiImprimirRelatorio
          .concat('?codTipoProcesso=')
          .concat(item.tipoProcesso.codTipoProcesso.toString())
        url = url
          .concat('&codSubassunto=')
          .concat(item.subassunto.codSubassunto.toString())
        url = url
          .concat('&numRota=')
          .concat(item.numRota.toString())
        url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      }

      // RELATÓRIO OBSERVAÇÃO POR SEQUÊNCIA
      if (self.relatorio === 'RELATORIO_OBSERVACAO_SEQUENCIA') {
        url = self.apiImprimirRelatorio
          .concat('?codProcesso=')
          .concat(item.codProcesso.toString())
        url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      }

      // RELATÓRIO MOVIMENTAÇÃO DOS PROCESSOS
      if (self.relatorio === 'RELATORIO_MOVIMENTACAO_PROCESSOS') {
        url = self.apiImprimirRelatorio
          .concat('?codProcesso=')
          .concat(item.codProcesso.toString())
        url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      }

      // RELATÓRIO GERAL DE PROCESSOS
      if (self.relatorio === 'RELATORIO_GERAL_PROCESSOS') {
        url = self.apiImprimirRelatorio
          .concat('?codProcesso=')
          .concat(item.codProcesso.toString())
        url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      }

      // COMPROVANTE DE MOVIMENTAÇÃO DE PROCESSO
      if (self.relatorio === 'COMPROVANTE_MOVIMENTACAO_PROCESSO') {
        url = this.apiImprimirRelatorio
          .concat('?codMovimentacao=')
          .concat(item.codMovimentacao.toString())
        url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
        url = url.concat('&nomComprovanteMovimento=').concat(self.parametrosSistema.nomComprovanteMovimento)
      }

      // COMPROVANTE DE ENCAMINHAMENTO DE PROCESSO
      if (self.relatorio === 'COMPROVANTE_ENCAMINHAMENTO_PROCESSO') {
        url = this.apiImprimirRelatorio
          .concat('?codProcesso=')
          .concat(item.codProcesso.toString())
        url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
        url = url.concat('&nomComprovanteEncaminhamento=').concat(self.parametrosSistema.nomComprovanteEncaminhamento)
      }

      // COMPROVANTE DE NOTIFICAÇÃO DE SOLICICAÇÃO DE COMPARECIMENTO
      if (self.relatorio === 'NOTIFICACAO_SOLICITACAO_COMPARECIMENTO') {
        url = this.apiImprimirRelatorio
          .concat('?codProcesso=')
          .concat(item.codProcesso.toString())
        url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      }

      // COMPROVANTE DE NOTIFICAÇÃO DE COMUNICADO DA SITUAÇÃO DO PROCESSO
      if (self.relatorio === 'NOTIFICACAO_COMUNICADO_SITUACAO_PROCESSO') {
        url = this.apiImprimirRelatorio
          .concat('?codProcesso=')
          .concat(item.codProcesso.toString())
        url = url.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      }

      // IMPRESSÃO ABRE EM NOVA GUIA
      utilHttp.httpGet(url, resposta => {
        window.open(url)
      })
    },
    imprimirLinhaSelecionadaLegadoCrystal (item) {
      var self = this
      let relatorioCrystal = {}

      // RELATÓRIO MOVIMENTAÇÃO DOS PROCESSOS
      if (self.relatorio === 'RELATORIO_MOVIMENTACAO_PROCESSOS') {
        var pCODPROCESSO = item.codProcesso.toString()
        var pNOMRELATORIOMOVIMENTACAOPROCESSOS = 'Relatório de Movimentação dos Processos'
        var pCODUSUARIO = self.$login.getCodUsuario()

        let params = [
          {
            nomParam: '@COD_PROCESSO',
            valParam: pCODPROCESSO
          },
          {
            nomParam: 'NOM_RELATORIO',
            valParam: pNOMRELATORIOMOVIMENTACAOPROCESSOS
          },
          {
            nomParam: 'COD_USUARIO',
            valParam: pCODUSUARIO
          }
        ]
        relatorioCrystal = {
          nomRelatorio: 'RelMovimentacaoProcessos_CrXI.rpt',
          desRelatorioCaminho: '/RelMovimentacaoProcessos_CrXI.rpt',
          parametros: params,
          conexaoStringList: [
            {
              nomRpt: 'RelMovimentacaoProcessos_CrXI.rpt',
              nomConexaoString: 'bancoDadosConexaoDB_ATENDIMENTO'
            }
          ]
        }
      } else if (self.relatorio === 'ROTEIROS_DOS_PROCESSOS') {
        debugger
        var pTIPOPROCESSO = item.tipoProcesso.codTipoProcesso
        var pNOMRELATORIOROTEIRO = 'Roteiros dos Processos'
        var pCODUSUARIOROTEIRO = self.$login.getCodUsuario()
        var pCODSUBASSUNTO = item.subassunto.codSubassunto
        var pNUMROTA = item.numRota

        let params = [
          {
            nomParam: '@TIPOPROCESSO',
            valParam: pTIPOPROCESSO
          },
          {
            nomParam: '@SUBASSUNTO',
            valParam: pCODSUBASSUNTO
          },
          {
            nomParam: '@ROTA',
            valParam: pNUMROTA
          },
          {
            nomParam: 'COD_USUARIO',
            valParam: pCODUSUARIOROTEIRO
          },
          {
            nomParam: 'NOM_RELATORIO',
            valParam: pNOMRELATORIOROTEIRO
          }
        ]
        relatorioCrystal = {
          nomRelatorio: 'RelRoteirosDosProcessos.rpt',
          desRelatorioCaminho: '/RelRoteirosDosProcessos.rpt',
          parametros: params,
          conexaoStringList: [
            {
              nomRpt: 'RelRoteirosDosProcessos.rpt',
              nomConexaoString: 'bancoDadosConexaoDB_ATENDIMENTO'
            }
          ]
        }
      }

      this.codArquivo = ''
      // Abrindo relatório
      utilHttp.httpPostRelatorioLegado(relatorioCrystal, (codArquivo) => {
      })
    },
    formatarStatus (valor) {
      switch (valor) {
        case 'ABE':
          return 'Aberto'
        case 'MOV':
          return 'Movimentado'
        case 'ENC':
          return 'Encerrado'
        case 'CAN':
          return 'Cancelado'
        case 'ARQ':
          return 'Arquivado'
        default:
          break
      }
    },
    getFiltroPesquisa () {
      var self = this
      var filtro = ''

      self.tratarDataInicial()
      self.tratarDataFinal()

      if (self.dataInicial && self.dataFinal) {
        if (self.dtFinal < self.dtInicial) {
          util.exibirToastAviso('Favor verificar a data informada')
        }
      }

      if (self.requerente.codRequerente) {
        filtro = filtro
          .concat('&codRequerente=')
          .concat(self.requerente.codRequerente)
      }
      if (self.numInicialProcesso) {
        filtro = filtro
          .concat('&numInicialProcesso=')
          .concat(self.numInicialProcesso)
      }
      if (self.numFinalProcesso) {
        filtro = filtro
          .concat('&numFinalProcesso=')
          .concat(self.numFinalProcesso)
      }
      if (self.anoInicial) {
        filtro = filtro
          .concat('&anoProcesso=')
          .concat(self.anoInicial)
      }
      if (self.anoFinal) {
        filtro = filtro
          .concat('&anoProcessoFinal=')
          .concat(self.anoFinal)
      }
      if (self.dataInicial) {
        filtro = filtro
          .concat('&dataInicial=')
          .concat(self.dtInicial)
          .concat('T00:00:00.000-00:00')
      }
      if (self.dataFinal) {
        filtro = filtro
          .concat('&dataFinal=')
          .concat(self.dtFinal)
          .concat('T23:59:59.999-05:00')
      }
      if (self.codOrgaoOrigem) {
        filtro = filtro
          .concat('&codOrgaoOrigem=')
          .concat(self.codOrgaoOrigem)
      }
      if (self.codUnidadeOrigem) {
        filtro = filtro
          .concat('&codUnidadeOrigem=')
          .concat(self.codUnidadeOrigem)
      }
      if (self.codSetorOrigem) {
        filtro = filtro
          .concat('&codSetorOrigem=')
          .concat(self.codSetorOrigem)
      }
      if (self.codOrgaoDestino) {
        filtro = filtro
          .concat('&codOrgaoDestino=')
          .concat(self.codOrgaoDestino)
      }
      if (self.codUnidadeDestino) {
        filtro = filtro
          .concat('&codUnidadeDestino=')
          .concat(self.codUnidadeDestino)
      }
      if (self.codSetorDestino) {
        filtro = filtro
          .concat('&codSetorDestino=')
          .concat(this.codSetorDestino)
      }
      if (self.relatorio === 'COMPROVANTE_MOVIMENTACAO_PROCESSO') {
        filtro = filtro
          .concat('&indStatusProcesso=')
          .concat('MOV')
      } else if (self.indStatusProcesso && self.indStatusProcesso !== 'TOD') {
        filtro = filtro
          .concat('&indStatusProcesso=')
          .concat(self.indStatusProcesso)
      }
      if (self.codTipoProcesso) {
        filtro = filtro
          .concat('&codTipoProcesso=')
          .concat(self.codTipoProcesso)
      }
      if (self.anoInicialRemessa) {
        filtro = filtro
          .concat('&anoRemessa=')
          .concat(self.anoInicialRemessa)
      }
      if (self.anoFinalRemessa) {
        filtro = filtro
          .concat('&anoRemessaFinal=')
          .concat(self.anoFinalRemessa)
      }
      if (self.numInicialRemessa) {
        filtro = filtro
          .concat('&numRemessa=')
          .concat(self.numInicialRemessa)
      }
      if (self.numFinalRemessa) {
        filtro = filtro
          .concat('&numRemessaFinal=')
          .concat(self.numFinalRemessa)
      }
      if (self.indStatusRemessa && self.indStatusRemessa !== 'TOD') {
        filtro = filtro
          .concat('&indStatusRemessa=')
          .concat(self.indStatusRemessa)
      }
      if (self.codUsuarioResponsavelAbertura) {
        filtro = filtro
          .concat('&codUsuarioResponsavelAbertura=')
          .concat(self.codUsuarioResponsavelAbertura)
      }
      if (self.codAssunto) {
        filtro = filtro
          .concat('&codAssunto=')
          .concat(self.codAssunto)
      }
      if (self.codSubassunto) {
        filtro = filtro
          .concat('&codSubAssunto=')
          .concat(self.codSubassunto)
      }
      if (self.$login.getCodUsuario()) filtro = filtro.concat('&codUsuario=').concat(self.$login.getCodUsuario())
      return filtro
    },
    getFiltroUnidadeOrigem () {
      var filtro = ''
      filtro = filtro.concat('/').concat(this.codOrgaoOrigem)
      return filtro
    },
    getFiltroSetorOrigem () {
      var filtro = ''
      filtro = filtro.concat('/').concat(this.codUnidadeOrigem)
      return filtro
    },
    getFiltroUnidadeDestino () {
      var filtro = ''
      filtro = filtro.concat('/').concat(this.codOrgaoDestino)
      return filtro
    },
    getFiltroSetorDestino () {
      var filtro = ''
      filtro = filtro.concat('/').concat(this.codUnidadeDestino)
      return filtro
    },
    limparFiltro () {
      var self = this
      self.indStatusProcesso = 'TOD'
      self.requerente = {}
      self.numInicialProcesso = ''
      self.numFinalProcesso = ''
      self.numInicialRemessa = ''
      self.numFinalRemessa = ''
      self.dataInicial = ''
      self.dataFinal = ''
      self.dtInicial = ''
      self.dtFinal = ''
      self.codSetorOrigem = ''
      self.codSetorDestino = ''
      self.codUnidadeOrigem = ''
      self.codUnidadeDestino = ''
      self.codOrgaoOrigem = ''
      self.codOrgaoDestino = ''
      self.codTipoProcesso = ''
      if (self.$refs['refRequerente'] !== undefined) { self.$refs['refRequerente'].limpar() }
      if (self.$refs['refOrgaoOrigem'] !== undefined) { self.$refs['refOrgaoOrigem'].limpar() }
      if (self.$refs['refUnidadeOrigem'] !== undefined) { self.$refs['refUnidadeOrigem'].limpar() }
      if (self.$refs['refSetorOrigem'] !== undefined) { self.$refs['refSetorOrigem'].limpar() }
      if (self.$refs['refOrgaoDestino'] !== undefined) { self.$refs['refOrgaoDestino'].limpar() }
      if (self.$refs['refUnidadeDestino'] !== undefined) { self.$refs['refUnidadeDestino'].limpar() }
      if (self.$refs['refSetorDestino'] !== undefined) { self.$refs['refSetorDestino'].limpar() }
      if (self.$refs['refTipoProcesso'] !== undefined) { self.$refs['refTipoProcesso'].limpar() }
      if (self.$refs['refUsuarioResponsavelAbertura'] !== undefined) { self.$refs['refUsuarioResponsavelAbertura'].limpar() }

      self.$refs['refDataTableRoteirosDosProcessos'].limpar()
      self.$refs['refDataTableRoteirosDosProcessos'].setDadosSelecionadosCheckbox([])
      self.$refs['refDataTableComprovanteEncaminhamento'].limpar()
      self.$refs['refDataTableComprovanteEncaminhamento'].setDadosSelecionadosCheckbox([])
      self.$refs['refDataTableComprovanteMovimentacao'].limpar()
      self.$refs['refDataTableComprovanteMovimentacao'].setDadosSelecionadosCheckbox([])
      self.$refs['refDataTableNotificacaoComparecimento'].limpar()
      self.$refs['refDataTableNotificacaoComparecimento'].setDadosSelecionadosCheckbox([])
      self.$refs['refDataTableNotificacaoComunicadoSituacaoProcesso'].limpar()
      self.$refs['refDataTableNotificacaoComunicadoSituacaoProcesso'].setDadosSelecionadosCheckbox([])
      self.$refs['refDataTableRelatorioGeralProcessos'].limpar()
      self.$refs['refDataTableRelatorioGeralProcessos'].setDadosSelecionadosCheckbox([])
      self.$refs['refDataTableRelatorioObservacaoSequencia'].limpar()
      self.$refs['refDataTableRelatorioObservacaoSequencia'].setDadosSelecionadosCheckbox([])
      self.$refs['refDataTableRelatorioMovimentacaoProcessos'].limpar()
      self.$refs['refDataTableRelatorioMovimentacaoProcessos'].setDadosSelecionadosCheckbox([])
      self.$refs['refDataTableRelatorioMapaEstatistico'].limpar()
      self.$refs['refDataTableRelatorioProcessosIncluidosRemessa'].limpar()
      self.exibirDataTableComprovanteEncaminhamento = false
      self.exibirDataTableComprovanteMovimentacao = false
      self.exibirDataTableNotificacaoComparecimento = false
      self.exibirDataTableNotificacaoComunicadoSituacaoProcesso = false
      self.exibirDataTableRelatorioGeralProcessos = false
      self.exibirDataTableRoteirosDosProcessos = false
      self.exibirDataTableRelatorioObservacaoSequencia = false
      self.exibirDataTableRelatorioMovimentacaoProcessos = false
      self.exibirDataTableRelatorioMapaEstatistico = false
      self.exibirDataTableRelatorioProcessosIncluidosRemessa = false
      self.exibirDataTableRelatorioRemessas = false
      self.anoInicial = new Date().getFullYear()
      self.anoFinal = new Date().getFullYear()
      self.anoInicialRemessa = new Date().getFullYear()
      self.anoFinalRemessa = new Date().getFullYear()
      self.exibirBotoes = false
    },
    pesquisarPrimeiraPagina () {
      var self = this

      if (util.validarComponentes(this.$refs)) {
        if (self.relatorio === 'ROTEIROS_DOS_PROCESSOS') {
          self.exibirDataTableRoteirosDosProcessos = true
          self.exibirBotoes = true
          if (self.$refs['refDataTableRoteirosDosProcessos']) {
            self.$refs['refDataTableRoteirosDosProcessos'].limpar()
            self.$refs['refDataTableRoteirosDosProcessos'].setDadosSelecionadosCheckbox([])
          }
          setTimeout(() => {
            self.$refs['refDataTableRoteirosDosProcessos'].pesquisar(1)
          }, 1)
        }

        if (self.relatorio === 'RELATORIO_REMESSAS_POR_PROCESSO') {
          self.exibirDataTableRelatorioRemessas = true
          self.exibirBotoes = true
          setTimeout(() => {
            self.$refs['refDataTableRelatorioRemessasPorProcesso'].pesquisar(1)
          }, 1)
        }

        if (self.relatorio === 'RELATORIO_PROCESSOS_INCLUIDOS_REMESSA') {
          self.exibirDataTableRelatorioProcessosIncluidosRemessa = true
          self.exibirBotoes = true
          setTimeout(() => {
            self.$refs['refDataTableRelatorioProcessosIncluidosRemessa'].pesquisar(1)
          }, 1)
        }

        if (self.relatorio === 'RELATORIO_MAPA_ESTATISTICO') {
          self.exibirDataTableRelatorioMapaEstatistico = true
          self.exibirBotoes = true
          setTimeout(() => {
            self.$refs['refDataTableRelatorioMapaEstatistico'].pesquisar(1)
          }, 1)
        }

        if (self.relatorio === 'RELATORIO_OBSERVACAO_SEQUENCIA') {
          self.exibirDataTableRelatorioObservacaoSequencia = true
          self.exibirBotoes = true
          if (self.$refs['refDataTableRelatorioObservacaoSequencia']) {
            self.$refs['refDataTableRelatorioObservacaoSequencia'].limpar()
            self.$refs['refDataTableRelatorioObservacaoSequencia'].setDadosSelecionadosCheckbox([])
          }
          setTimeout(() => {
            self.$refs['refDataTableRelatorioObservacaoSequencia'].pesquisar(1)
          }, 1)
        }

        if (self.relatorio === 'RELATORIO_MOVIMENTACAO_PROCESSOS') {
          self.exibirDataTableRelatorioMovimentacaoProcessos = true
          self.exibirBotoes = true
          if (self.$refs['refDataTableRelatorioMovimentacaoProcessos']) {
            self.$refs['refDataTableRelatorioMovimentacaoProcessos'].limpar()
            self.$refs['refDataTableRelatorioMovimentacaoProcessos'].setDadosSelecionadosCheckbox([])
          }
          setTimeout(() => {
            self.$refs['refDataTableRelatorioMovimentacaoProcessos'].pesquisar(1)
          }, 1)
        }

        if (self.relatorio === 'RELATORIO_GERAL_PROCESSOS') {
          self.exibirDataTableRelatorioGeralProcessos = true
          self.exibirBotoes = true
          if (self.$refs['refDataTableRelatorioGeralProcessos']) {
            self.$refs['refDataTableRelatorioGeralProcessos'].limpar()
            self.$refs['refDataTableRelatorioGeralProcessos'].setDadosSelecionadosCheckbox([])
          }
          setTimeout(() => {
            self.$refs['refDataTableRelatorioGeralProcessos'].pesquisar(1)
          }, 1)
        }

        if (self.relatorio === 'COMPROVANTE_ENCAMINHAMENTO_PROCESSO') {
          self.exibirDataTableComprovanteEncaminhamento = true
          self.exibirBotoes = true
          if (self.$refs['refDataTableComprovanteEncaminhamento']) {
            self.$refs['refDataTableComprovanteEncaminhamento'].limpar()
            self.$refs['refDataTableComprovanteEncaminhamento'].setDadosSelecionadosCheckbox([])
          }
          setTimeout(() => {
            self.$refs['refDataTableComprovanteEncaminhamento'].pesquisar(1)
          }, 1)
        }

        if (self.relatorio === 'COMPROVANTE_MOVIMENTACAO_PROCESSO') {
          self.exibirDataTableComprovanteMovimentacao = true
          self.exibirBotoes = true
          if (self.$refs['refDataTableComprovanteMovimentacao']) {
            self.$refs['refDataTableComprovanteMovimentacao'].limpar()
            self.$refs['refDataTableComprovanteMovimentacao'].setDadosSelecionadosCheckbox([])
          }
          setTimeout(() => {
            self.$refs['refDataTableComprovanteMovimentacao'].pesquisar(1)
          }, 1)
        }

        if (self.relatorio === 'NOTIFICACAO_SOLICITACAO_COMPARECIMENTO') {
          self.exibirDataTableNotificacaoComparecimento = true
          self.exibirBotoes = true
          if (self.$refs['refDataTableNotificacaoComparecimento']) {
            self.$refs['refDataTableNotificacaoComparecimento'].limpar()
            self.$refs['refDataTableNotificacaoComparecimento'].setDadosSelecionadosCheckbox([])
          }
          setTimeout(() => {
            self.$refs['refDataTableNotificacaoComparecimento'].pesquisar(1)
          }, 1)
        }

        if (self.relatorio === 'NOTIFICACAO_COMUNICADO_SITUACAO_PROCESSO') {
          self.exibirDataTableNotificacaoComunicadoSituacaoProcesso = true
          self.exibirBotoes = true
          if (self.$refs['refDataTableNotificacaoComunicadoSituacaoProcesso']) {
            self.$refs['refDataTableNotificacaoComunicadoSituacaoProcesso'].limpar()
            self.$refs['refDataTableNotificacaoComunicadoSituacaoProcesso'].setDadosSelecionadosCheckbox([])
          }
          setTimeout(() => {
            self.$refs['refDataTableNotificacaoComunicadoSituacaoProcesso'].pesquisar(1)
          }, 1)
        }
      }
    },
    imprimirR (relatorio) {
      this.exibirDataTableComprovanteMovimentacao = false
      this.exibirDataTableComprovanteEncaminhamento = false
      this.exibirDataTableNotificacaoComparecimento = false
      this.exibirDataTableNotificacaoComunicadoSituacaoProcesso = false
      this.exibirDataTableRelatorioGeralProcessos = false
      this.exibirDataTableRoteirosDosProcessos = false
      this.exibirDataTableRelatorioObservacaoSequencia = false
      this.exibirDataTableRelatorioMovimentacaoProcessos = false
      this.exibirDataTableRelatorioMapaEstatistico = false
      this.exibirDataTableRelatorioProcessosIncluidosRemessa = false
      this.exibirDataTableRelatorioRemessas = false
      this.exibirBotoes = false

      switch (relatorio) {
        case 'ROTEIROS_DOS_PROCESSOS':
          this.apiImprimirRelatorio = api.RELATORIO_RELATORIO_ROTEIROS_DOS_PROCESSOS
          break
        case 'RELATORIO_REMESSAS_POR_PROCESSO':
          this.apiImprimirRelatorio = api.RELATORIO_RELATORIO_REMESSAS_POR_PROCESSO
          break
        case 'RELATORIO_PROCESSOS_INCLUIDOS_REMESSA':
          this.apiImprimirRelatorio = api.RELATORIO_RELATORIO_PROCESSOS_INCLUIDOS_REMESSA
          break
        case 'RELATORIO_MAPA_ESTATISTICO':
          this.apiImprimirRelatorio = api.RELATORIO_RELATORIO_MAPA_ESTATISTICO
          break
        case 'RELATORIO_OBSERVACAO_SEQUENCIA':
          this.apiImprimirRelatorio = api.RELATORIO_RELATORIO_OBSERVACAO_SEQUENCIA
          break
        case 'RELATORIO_MOVIMENTACAO_PROCESSOS':
          this.apiImprimirRelatorio = api.RELACAO_RELATORIO_MOVIMENTACAO_PROCESSOS_GERAL
          break
        case 'RELATORIO_GERAL_PROCESSOS':
          this.indStatusProcesso = 'TOD'
          this.apiImprimirRelatorio = api.RELATORIO_RELATORIO_GERAL_PROCESSOS
          break
        case 'NOTIFICACAO_COMUNICADO_SITUACAO_PROCESSO':
          this.apiImprimirRelatorio = api.RELATORIO_NOTIFICACAO_COMUNICADO_SITUACAO_PROCESSO
          break
        case 'NOTIFICACAO_SOLICITACAO_COMPARECIMENTO':
          this.apiImprimirRelatorio = api.RELATORIO_NOTIFICACAO_SOLICITACAO_COMPARECIMENTO
          break
        case 'COMPROVANTE_ENCAMINHAMENTO_PROCESSO':
          this.apiImprimirRelatorio = api.RELATORIO_COMPROVANTE_ENCAMINHAMENTO
          break
        case 'COMPROVANTE_MOVIMENTACAO_PROCESSO':
          this.apiImprimirRelatorio = api.RELATORIO_MOVIMENTACAO_PROCESSO
          break
        default:
          break
      }
    },
    filtroPesquisaSubAssunto () {
      return '/'.concat(this.codAssunto)
    },
    tratarDataInicial () {
      var self = this

      if (self.dataInicial !== null && self.dataInicial !== undefined && self.dataInicial !== '') {
        let di = new Date(util.formatarAnoMesDia(self.dataInicial, 'DD/MM/YYYY'))
        let dia = String(di.getDate()).padStart(2, '0')
        let mes = String(di.getMonth() + 1).padStart(2, '0')
        let ano = String(di.getFullYear())

        var dInicial = ano + '-' + mes + '-' + dia

        self.dtInicial = dInicial
      }
    },
    tratarDataFinal () {
      var self = this

      if (self.dataFinal !== null && self.dataFinal !== undefined && self.dataFinal !== '') {
        let df = new Date(util.formatarAnoMesDia(self.dataFinal, 'DD/MM/YYYY'))
        let dia = String(df.getDate()).padStart(2, '0')
        let mes = String(df.getMonth() + 1).padStart(2, '0')
        let ano = String(df.getFullYear())

        var dFinal = ano + '-' + mes + '-' + dia

        self.dtFinal = dFinal
      }
    }
  },
  watch: {
    relatorio: {
      handler (valor) {
        if (this.relatorio) {
          this.imprimirR(this.relatorio)
        }
      },
      deep: true
    },
    codOrgaoOrigem: {
      handler (valor) {
        var self = this
        self.changeOrgaoOrigem()
        if (self.codOrgaoOrigem === undefined || self.codOrgaoOrigem === '') {
          if (self.$refs['refUnidadeOrigem'] !== undefined) { self.$refs['refUnidadeOrigem'].limpar() }
          self.desabilitarUnidadeOrigem = true
        } else {
          self.desabilitarUnidadeOrigem = false
        }
      }
    },
    codUnidadeOrigem: {
      handler (valor) {
        var self = this
        self.changeUnidadeOrigem()
        if (
          self.codUnidadeOrigem === undefined ||
          self.codUnidadeOrigem === ''
        ) {
          if (self.$refs['refSetorOrigem'] !== undefined) { self.$refs['refSetorOrigem'].limpar() }
          self.desabilitarSetorOrigem = true
        } else {
          self.desabilitarSetorOrigem = false
        }
      }
    },
    codOrgaoDestino: {
      handler (valor) {
        var self = this
        self.changeOrgaoDestino()
        if (self.codOrgaoDestino === undefined || self.codOrgaoDestino === '') {
          if (self.$refs['refUnidadeDestino'] !== undefined) { self.$refs['refUnidadeDestino'].limpar() }
          self.desabilitarUnidadeDestino = true
        } else {
          self.desabilitarUnidadeDestino = false
        }
      }
    },
    codUnidadeDestino: {
      handler (valor) {
        var self = this
        self.changeUnidadeDestino()
        if (
          self.codUnidadeDestino === undefined ||
          self.codUnidadeDestino === ''
        ) {
          if (self.$refs['refSetorDestino'] !== undefined) { self.$refs['refSetorDestino'].limpar() }
          self.desabilitarSetorDestino = true
        } else {
          self.desabilitarSetorDestino = false
        }
      }
    },
    codTipoProcesso: {
      handler (valor) {
        var self = this
        self.changeTipoProcesso()
        if (self.codTipoProcesso === undefined || self.codTipoProcesso === '') {
          if (self.$refs['refAssunto'] !== undefined) { self.$refs['refAssunto'].limpar() }
          self.desabilitarAssunto = true
        } else {
          self.desabilitarAssunto = false
        }
      }
    },
    codAssunto: {
      handler (valor) {
        var self = this
        self.changeAssunto()
        if (self.codAssunto === undefined || self.codAssunto === '') {
          if (self.$refs['refSubAssunto'] !== undefined) { self.$refs['refSubAssunto'].limpar() }
          self.desabilitarSubAssunto = true
        } else {
          self.desabilitarSubAssunto = false
        }
      }
    },
    local: {
      handler (valor) {
        var self = this
        if (valor) {
          if (valor === 'Origem') {
            if (self.$refs['refOrgaoDestino'] !== undefined) { self.$refs['refOrgaoDestino'].limpar() }
            if (self.$refs['refUnidadeDestino'] !== undefined) { self.$refs['refUnidadeDestino'].limpar() }
            if (self.$refs['refSetorDestino'] !== undefined) { self.$refs['refSetorDestino'].limpar() }
            self.codOrgaoDestino = undefined
            self.codUnidadeDestino = undefined
            self.codSetorDestino = undefined
          } else {
            if (self.$refs['refOrgaoOrigem'] !== undefined) { self.$refs['refOrgaoOrigem'].limpar() }
            if (self.$refs['refUnidadeOrigem'] !== undefined) { self.$refs['refUnidadeOrigem'].limpar() }
            if (self.$refs['refSetorOrigem'] !== undefined) { self.$refs['refSetorOrigem'].limpar() }
            self.codOrgaoOrigem = undefined
            self.codUnidadeOrigem = undefined
            self.codSetorOrigem = undefined
          }
        }
      }
    }
  },
  mounted () {
    this.paginaStatus.caminhoMigalha = [
      {
        icone: 'far fa-file-alt',
        descricao: 'Gestão de Processos',
        rotaNome: 'Relatorios'
      }
    ]
    this.anoInicial = new Date().getFullYear()
    this.anoFinal = new Date().getFullYear()
    this.anoInicialRemessa = new Date().getFullYear()
    this.anoFinalRemessa = new Date().getFullYear()
    this.indStatusProcesso = 'TOD'
    this.indStatusRemessa = 'TOD'
    this.relatorio = ''
    this.local = 'Origem'
    this.buscarParametroSistema()
  },
  components: {
    GBreadcrumb,
    GPesquisa,
    GInput,
    GAutocomplete,
    // GDatepicker,
    GSelect,
    GDatatable,
    GDateInput
  }
}
</script>
